import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { Roller } from "react-awesome-spinners";
import Form from "react-bootstrap/Form";
import "./Appointment.css";
import BootstrapTable from "react-bootstrap-table-next";
import pagination from "./pagination";
import { TbHotelService, TbCalendar, TbClock } from "react-icons/tb";
import {
  FaRegEdit,
  FaCheck,
  FaThumbsDown,
  FaRegTimesCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaMoneyBillAlt,
  FaToggleOn,
} from "react-icons/fa";
import { MdAdd, MdClose } from "react-icons/md";
import { RiDeleteBin6Line, RiCloseCircleFill } from "react-icons/ri";
import { BsStopwatch, BsPlusLg } from "react-icons/bs";
import {
  userslist,
  getactivestaff,
  getbookingservices,
  getEditbookingData,
  getStaff,
  updateBookingData,
  confirmbookingstatus,
  confirmbookingstatusFSR,
  rejectbookingstatus,
  cancelbookingbyidadmin,
  reccuringcancelbooking,
  getrescheduledata,
  getDates,
  getZone,
  unconfirmbookingstatus,
  complatebookingstatus,
  disuncnfcomplatebookingstatus,
  uncomplatebookingstatus,
  activebookingstatus,
  createStaxIdApi,
  createinvoiceApi,
  getsubserviceaddonsApi,
  getinvoiceApi,
  sendinvoicetouserapi,
  createPaymentMethod,
  getpaymentMethod,
  payinvoiceApi,
  checkemailApi,
  getpreferredstaffApi,
  getbookingservicesApi,
  updaterecurringbookingAPi,
  findzonebyzipApi,
  getproductlistdataApi,
  updatecrmdataApi,
  getstaxaccount,
  savestaxtolillypad,
  gettimesheetbooking,
  updatetimesheet,
  addedittimesheet,
  getBookingById,
  createQBSalesReceiptApi
} from "../Api/bookingApi";
import "react-notifications/lib/notifications.css";
import Select from "react-select";
import moment from "moment";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { usePaymentInputs } from "react-payment-inputs";
import ChildComponent from "../Components/EditUser/Informasi";
import { LuExternalLink } from "react-icons/lu";
import { GrFormEdit } from "react-icons/gr";
import { IoIosAddCircleOutline } from "react-icons/io";

import InputMask from "react-input-mask";

// import {date_time}  from "../helper/timezone";

import { Link } from "react-router-dom";
import { useConfirmModal } from "../hooks/useConfirmModal";
import CommonConfirmModal from "../Components/Modal/CommonConfirmModal";

import { notify } from "../utils/notify";

function SalesReceiptButton({ row, orderId, customerId, clientId }) {
  const [creating, setCreating] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (creating) return;

    setCreating(true);

    const formData = new FormData();
    formData.append("stax_invoice_id", row.id);
    formData.append("order_id", orderId || "");
    formData.append("customer_id", customerId || "");
    formData.append("amount", row.total || 0);
    formData.append("client_id", clientId || "");

    createQBSalesReceiptApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (
            response.data?.status === "1" ||
            response.data?.status === "success"
          ) {
            NotificationManager.success(
              response.data?.message ||
                "Sales Receipt created successfully in QuickBooks"
            );
          } else {
            NotificationManager.error(
              response.data?.message || "Failed to create Sales Receipt"
            );
          }
        } else {
          NotificationManager.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
        NotificationManager.error("Something went wrong");
      })
      .finally(() => {
        setCreating(false);
      });
  };

  return (
    <Button
      className="Enable-Active-bttn invoice-list-btn"
      style={{ fontSize: "11px", whiteSpace: "nowrap" }}
      onClick={handleClick}
      disabled={creating}
    >
      {creating ? "Creating..." : "Sales Receipt"}
    </Button>
  );
}

function Appointment({
  order_id,
  onCloseidChangebooking,
  onCloseidChangeoldbookingid,
  onclosepopup,
}) {
  const [bookingDetails, setBookingDetails] = useState([]);
  const confirmModal = useConfirmModal();

  const [showBookingDetails, setShowBookingDeatils] = useState(false);
  const digitsOnly = (s = "") => String(s).replace(/\D/g, "");
  const handleClose2 = () => setShowBookingDeatils(false);
  const handleShow2 = () => setShowBookingDeatils(true);

  const getBookingDetails = (id) => {
    setLoading(true);
    const order_id = id;
    const formData = new FormData();
    formData.append("order_id", order_id);
    getBookingById(formData)
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;
          setBookingDetails(apiResponse.data);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
        setShowBookingDeatils(true);
        onclosepopup(false);
      });
  };

  useEffect(() => {
    if (order_id) {
      getBookingDetails(order_id);
    }
  }, [order_id]);

  const dateData = moment(new Date()).format("YYYY-MM-DD");

  const [bookingDate, setBookingDate] = useState(dateData);
  const [recurringtime, setRecurringtime] = useState(dateData);
  const [editstart, setEditstart] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setBookingDate(dateData);
    setRecurringtime(moment(dateData).format("HH:mm:ss"));
  }, [dateData]);

  const [users, setUsers] = useState([]);
  const [activeStaff, setActiveStaff] = useState([]);
  const [service, setService] = useState([]);
  const [subService, setSubService] = useState([]);
  const [ChooseService, setChooseService] = useState([]);

  const [ChooseStaff, setChooseStaff] = useState([]);
  const [editbooking, setEditbooking] = useState([]);
  const [staffList, setStaffList] = useState(null);
  const [assignStaff, setAssignStaff] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [userType, setUserType] = useState(0);

  const getStaffList = () => {
    getactivestaff()
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;
          setStaffList(apiResponse.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getStaffList();
  }, []);

  const [searchkeyword, setSearchkeyword] = useState("");
  const [pageno, setPageno] = useState(1);

  const userdata = (type) => {
    userslist(searchkeyword, type == "search" ? 1 : pageno)
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;
          if (apiResponse.data.length > 0) {
            if (type === "scroll") {
              setUsers([...users, ...apiResponse.data]);
              setPageno(pageno + 1);
            } else {
              setUsers(apiResponse.data);
            }
          } else {
            if (type === "search") {
              setUsers([]);
            }
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    userdata();
    getstaff();
    productlistdata();
  }, []);

  useEffect(() => {
    getservices(userType);
  }, [userType]);

  useEffect(() => { }, [selectedOptions]);

  useEffect(() => {
    if (searchkeyword !== "") {
      setPageno(1);
      userdata("search");
    }
  }, [searchkeyword]);

  // create a function to convert hh:mm in minutes
  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(":");
    return parseInt(hours) * 60 + parseInt(minutes);
  };

  useEffect(() => {
    // convert hh:mm in minutes
  }, [ChooseStaff]);

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show6, setShow6] = useState(false);

  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [showCustomer, setShowCustomer] = useState(false);

  const handleCloseCustomer = () => setShowCustomer(false);
  const handleShowCustomer = () => setShowCustomer(true);

  const [show5, setShow5] = useState(false);

  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [addons, setAddons] = React.useState([]);
  const [servicepercentage, setServicepercentage] = React.useState(0);

  const getstaff = () => {
    getactivestaff().then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        setActiveStaff(apiResponse.data);
      } else {
        notify.error("Something went wrong");
      }
    });
  };

  const getservices = (userType) => {
    getbookingservices(userType).then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        setService(apiResponse.data);
      } else {
        notify.error("Something went wrong");
      }
    });
  };

  const [basewithextra, setBasewithextra] = useState(0);

  const [eventcount, setEventcount] = useState(0);

  const getStatusofbookings = (bookingstatus = "") => {
    if (bookingstatus === "A") {
      return "Unconfirmed";
    } else if (bookingstatus === "C") {
      return "Confirm";
    } else if (bookingstatus === "R") {
      return "Reject";
    } else if (bookingstatus === "CC") {
      return "Cancel by Client";
    } else if (bookingstatus === "CS") {
      return "Cancel by service provider";
    } else if (bookingstatus === "CO") {
      return "Completed";
    } else if (bookingstatus === "MN") {
      return "Mark as no show";
    } else if (bookingstatus === "UC") {
      return "Confirmed by Client";
    } else {
      return "";
    }
  };

  const getDateFormate = (appointmentstarttime = "") => {
    if (appointmentstarttime === null) {
      return "";
    } else {
      const date = appointmentstarttime.split(" ");
      const dateformate = date[0].split("-");
      const month = new Date(
        dateformate[0],
        dateformate[1] - 1,
        dateformate[2]
      );
      const monthname = month.toLocaleString("default", { month: "short" });
      return `${monthname}-${dateformate[2]}-${dateformate[0]}`;
    }
  };

  const getassigendstaff = (staff = "") => {
    if (staff === null) {
      return "";
    } else {
      const staffname = staff.replace(/(<([^>]+)>)/gi, "");
      return staffname;
    }
  };

  const getNotes = (bookingnotes = "") => {
    if (bookingnotes === null) {
      return "";
    } else {
      const notes = bookingnotes.replace(/(?:\r\n|\r|\n)/g, "<br />");
      const notes1 = notes.replace(/(<([^>]+)>)/gi, "");
      return notes1;
    }
  };

  const [edituser, setEdituser] = useState({
    id: "",
    image: null,
    user_email: "",
    user_pwd: "",
    first_name: "",
    last_name: "",
    phone: "",
    zip: "",
    address: "",
    city: "",
    state: "",
    notes: "",
    preferences: "",
    family_info: "",
    parking_access: "",
    preferrend_technician: "",
    special_instructions: "",
    technician_notes: "",
    appointment_note_by_staff: "",
    bathrooms: "",
    bedrooms: "",
    billed_amount: "",
    key_number: "",
    billed_hours: "",
    work_phone: "",
    message_phone: "",
    special_instructions_admin: "",
    payment_method_id: "",
    shipping_address: "",
    shipping_zip: "",
    shipping_city: "",
    shipping_state: "",
    customer_stage: "",
    zone: "",
    client_owner: "",
    email_status: "E",
    sms_status: "E",
    stax_payment_method: "",
    customer_id: "",
    estimated_duration: "",
    estimated_price: "",
  });

  const [preferredStaff, setPreferredStaff] = useState([]);

  const getpreferredstaff = () => {
    getpreferredstaffApi()
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setPreferredStaff(response.data.data);
          } else {
            notify.error("data not found");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getpreferredstaff();
  }, [edituser]);

  function convertTimeTo24Hour(time) {
    // Split the time into hours, minutes, and AM/PM components
    const [timeString, modifier] = time.split(" ");
    const [hours, minutes] = timeString.split(":");

    // Convert hours to 24-hour format
    let hours24 = parseInt(hours, 10);
    if ((modifier == "pm" || modifier == "PM") && hours24 !== 12) {
      hours24 += 12;
    } else if ((modifier == "am" || modifier == "AM") && hours24 === 12) {
      hours24 = 0;
    }

    // Pad the hours and minutes with leading zeros if necessary
    const formattedHours = String(hours24).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");

    // Return the time in 24-hour format
    return `${formattedHours}:${formattedMinutes}`;
  }

  const [EditbookingStartTime, setEditbookingStartTime] = useState(null);
  const [EditbookingEndTime, setEditbookingEndTime] = useState(null);

  const [EditbookingStartDate, setEditbookingStartDate] = useState(null);
  const [EditbookingEndDate, setEditbookingEndDate] = useState(null);
  const [EditSubServices, setEditSubServices] = useState([]);
  const [editaddons, setEditAddons] = useState([]);
  const [updatestaff, setUpdatestaff] = useState([]);

  const getEditbooking = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    formData.append("client_id", bookingDetails.client_id);

    getEditbookingData(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            const apiResponse = response.data;
            setEditbooking(apiResponse.data);
            setEditbookingstate(apiResponse.data.appointment_state);
            setUpdatestaff(apiResponse.data.staff_ids);
            const staff_ids = apiResponse.data.staff_ids;
            const staff_ids_array = staff_ids.split(",");
            const staff_ids_index = [];
            staff_ids_array.forEach((staff_id) => {
              const index = staffList.findIndex(
                (staff) => staff.value === staff_id
              );
              staff_ids_index.push(index);
            });
            const selectedStaff = [];
            staff_ids_index.forEach((index) => {
              selectedStaff.push(staffList[index]);
            });
            setSelectedOptions(selectedStaff);

            const start_time = apiResponse.data.start_time;
            // const start_time = getbookingStartTime(apiResponse.data.start_time);

            setEditbookingStartTime(convertTimeTo24Hour(start_time));

            // setEditbookingStartTime(start_time);

            const end_time = getbookingStartTime(apiResponse.data.end_time);
            setEditbookingEndTime(end_time);

            const start_d_time = getbookingStartDate(
              apiResponse.data.booking_date_time
            );
            setEditbookingStartDate(start_d_time);

            const end_d_time = getbookingStartDate(
              apiResponse.data.booking_date_time
            );
            setEditbookingEndDate(end_d_time);

            setEditSubServices(apiResponse.data.subservices);
            setEditAddons(apiResponse.data.addons);
            const staff = apiResponse.data.staff_ids;
            setAssignStaff(selectedStaff);
            setEditbookingdiscount(apiResponse.data.booking_discount);

            const fullRequest = normalizeRequestValue(apiResponse.data.request);
            if (isEffectivelyEmptyRequest(fullRequest)) {
              setEditRequestedTechnician("");
              setEditBookingTime("");
              setEditClientNotes("");
              setEditHasCats(false);
              setEditHasDogs(false);
            } else {
              setEditRequestedTechnician(getRequestedTechnician(fullRequest) || "");
              const cleanedRequest = removeRequestedTechnicianFromRequest(fullRequest);
              const parsed = parseSpecialClientRequests(cleanedRequest);
              setEditBookingTime(parsed.bookingTime);
              setEditClientNotes(parsed.instructions);
              setEditHasCats(parsed.hasCats);
              setEditHasDogs(parsed.hasDogs);
            }
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        handleShow3();
      });
  };

  const getbookingStartDate = (bookingdatetime = "") => {
    const bookingDateTime = bookingdatetime.split(" ");
    const bookingDate = bookingDateTime[0];
    return bookingDate;
  };

  const getbookingStartTime = (start_time = "") => {
    var start_time = start_time.split(" ");
    var start_time1 = start_time[0].split(":");
    var starttime = start_time1[0] + ":" + start_time1[1];
    return starttime;
  };

  const handleEditInputChange3 = (event) => {
    const { name, value } = event.target;
    setEditbooking((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

  const [editbookingstate, setEditbookingstate] = useState(" ");

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [baseTime, setBaseTime] = useState(0);

  const [expectedtotalAmount, setExpectedTotalAmount] = useState(0);

  const [editbookingestimatedPrice, setEditbookingestimatedPrice] = useState(0);
  const [editbookingestimatedDuration, setEditbookingestimatedDuration] =
    useState("00:00");

  const [editbookingdiscount, setEditbookingdiscount] = useState(0);
  const [editbookingchangesamount, setEditbookingChangesAmount] = useState("");

  const [editBookingTime, setEditBookingTime] = useState("");
    const [editClientNotes, setEditClientNotes] = useState("");
    const [editHasCats, setEditHasCats] = useState(false);
    const [editHasDogs, setEditHasDogs] = useState(false);
    const [editRequestedTechnician, setEditRequestedTechnician] = useState("");
  

  const handlechageeditamount = (value) => {
    if (value != "") {
      var value = parseInt(value);
      setEditbookingestimatedPrice(value);
      // const totalAmountvar1 = (10 * value) / 11;
      const service_percentage = parseInt(editbooking.service_percentage);
      const totalAmountvar1 = ((100 - service_percentage) * value) / 100;
      setEditTotalAmount(parseInt(totalAmountvar1));
    } else {
      setEditTotalAmount(0);
      setEditbookingestimatedPrice(0);
    }
  };

  const handlechageeditdiscountamount = (value) => {
    if (value !== "") {
      var parsedValue = parseInt(value);
      setEditbookingdiscount(parsedValue);
      const discountprice = parseInt(editbookingestimatedPrice) - parsedValue;
      setEditbookingChangesAmount(parseInt(discountprice));

      var Servicepercentage = parseInt(editbooking.service_percentage);
      let totalAmountvar1;
      if (Servicepercentage > 0) {
        totalAmountvar1 =
          ((100 - Servicepercentage) * editbookingchangesamount) / 100;
      } else {
        totalAmountvar1 = parseInt(editbooking.billed_amount) - parsedValue;
      }

      setEditTotalAmount(parseInt(totalAmountvar1));
    } else {
      setEditTotalAmount(0);
      setEditbookingestimatedPrice(0);
    }
  };

  const handlechageedittime = (event) => {
    const inputValue = event.target.value;
    const [hours, minutes] = inputValue.split(":");
    const validMinutes = Math.min(Math.max(parseInt(minutes || 0, 10), 0), 59);
    const formattedValue = `${hours || "00"}:${validMinutes
      .toString()
      .padStart(2, "0")}`;
    let totalDurationvar = convertToMinutes(formattedValue);
    setEditbookingestimatedDuration(totalDurationvar);
    //setExpedtedendtime(totalDurationvar)

    const service_percentage = parseInt(editbooking.service_percentage);
    //const totalDurationvarwithextra = (totalDurationvar * 11) / servicepercentage;
    const totalDurationvarwithextra =
      ((100 - service_percentage) * totalDurationvar) / 100;

    // setEditBaseTime(parseInt(totalDurationvarwithextra / ChooseStaff.length));
    setEditBaseTime(parseInt(totalDurationvarwithextra));
  };

  useEffect(() => {
    getTimeData();
  }, [totalDuration]);

  const getTimeData = () => {
    setBaseTime(totalDuration);

    const expectedtime = basewithextra;
    setBasewithextra(expectedtime);
  };

  useEffect(() => {
    calculatePrice();
  }, [subService, addons, ChooseService]);

  useEffect(() => {
    setUpdatedendtime(parseInt(basewithextra / ChooseStaff.length));
  }, [ChooseStaff]);

  const [edittotalAmount, setEditTotalAmount] = useState(0);
  const [edittotalDuration, setEditTotalDuration] = useState(0);
  const [editbaseTime, setEditBaseTime] = useState(0);
  const [updatedendtime, setUpdatedendtime] = useState();
  const [expedtedendtime, setExpedtedendtime] = useState();

  useEffect(() => {
    getEditTimeData();
  }, [edittotalDuration]);

  const getEditTimeData = () => {
    // const start_time = edittotalDuration;
    // // var hours = Math.floor(start_time / 60);
    // // var minutes = start_time % 60;

    // // if (hours < 10) {
    // //   hours = "0" + hours;
    // // }
    // // else {
    // //   hours = hours;
    // // }
    // // if (minutes < 10) {
    // //   minutes = "0" + minutes;
    // // }
    // // else {
    // //   minutes = minutes;
    // // }

    // // var time = hours + ":" + minutes;
    setEditBaseTime(edittotalDuration);
  };

  useEffect(() => {
    // if (editstart) {

    const hours = parseInt(editbooking.hours) * 60;
    const mints = parseInt(editbooking.mints);
    const totalDuration = hours + mints;
    if (
      editbooking.estimated_price == null ||
      editbooking.estimated_price == ""
    ) {
      setEditbookingestimatedPrice(editbooking.billed_amount);

      var Servicepercentage = parseInt(editbooking.service_percentage);
      const percentage = (editbooking.billed_amount * Servicepercentage) / 100;
      const totalAmountvar1 = totalDuration + percentage;
      setEditTotalAmount(totalAmountvar1);
    } else {
      const priceRange = editbooking.estimated_price;
      // const [minPriceStr, maxPriceStr] = priceRange.split(' to ');
      const [minPriceStr, maxPriceStr] = priceRange.includes(" to ")
        ? priceRange.split(" to ")
        : priceRange.split(" - ");

      // Remove the dollar sign and convert the strings to numbers
      const minPrice = parseFloat(minPriceStr.replace("$", ""));
      const maxPrice = parseFloat(maxPriceStr.replace("$", ""));

      setEditTotalAmount(minPrice);
      setEditbookingestimatedPrice(maxPrice);
    }

    if (
      editbooking.estimated_duration == null ||
      editbooking.estimated_duration == ""
    ) {
      setEditbookingestimatedDuration(editbooking.order_duration);

      var Servicepercentage = parseInt(editbooking.service_percentage);
      const percentage = (totalDuration * Servicepercentage) / 100;
      const totalAmountvar1 = totalDuration + percentage;
      setEditBaseTime(totalAmountvar1);
    } else {
      const estimated_duration = editbooking.estimated_duration;

      // const [startTime, endTime] = estimated_duration.split(' to ');
      const [startTime, endTime] = estimated_duration.includes(" to ")
        ? estimated_duration.split(" to ")
        : estimated_duration.split(" - ");

      // Convert start and end times to minutes
      const [startHours, startMinutes] = startTime.split(":");
      const [endHours, endMinutes] = endTime.split(":");
      const startInMinutes = parseInt(startHours) * 60 + parseInt(startMinutes);
      const endInMinutes = parseInt(endHours) * 60 + parseInt(endMinutes);

      setEditbookingestimatedDuration(endInMinutes);

      setEditBaseTime(startInMinutes);
    }

    // setEditTotalDuration(editbaseTime);

    // }
  }, [
    editbooking.hours,
    editbooking.mints,
    editbooking.billed_amount,
    editbooking.estimated_duration,
  ]);

  useEffect(() => {
    const staffids = editbooking.staff_ids;

    if (Array.isArray(staffids)) {
      const staff_length = staffids.length > 0 ? staffids.length : 1;
      setUpdatestaff(staffids);
      setExpedtedendtime(parseInt(editbookingestimatedDuration / staff_length));
    } else {
      console.error("editbooking.staff_ids is not an array or is undefined.");
    }
  }, [editbooking.staff_ids, editbookingestimatedDuration]);

  useEffect(() => {
    if (editstart) {
      calculateEditPriceforbooking();
    }
  }, [EditSubServices, editaddons]);

  useEffect(() => {
    const staff_length = assignStaff.length > 0 ? assignStaff.length : 1;
    setExpedtedendtime(parseInt(editbookingestimatedDuration / staff_length));
  }, [assignStaff, editbookingestimatedDuration]);

  function changeeditaddons(value, id) {
    if (value === "increment") {
      const updatedArray = editaddons.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            addons_service_qty: parseInt(item.addons_service_qty) + 1,
          };
        }

        return item;
      });

      setEditAddons(updatedArray);
    } else if (value === "decrement") {
      const updatedArray = editaddons.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            addons_service_qty: parseInt(item.addons_service_qty) - 1,
          };
        }

        return item;
      });
      setEditAddons(updatedArray);
    }
  }

  function changeCounter3(value, id) {
    if (value === "increment") {
      const updatedArray = EditSubServices.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            quantity: parseInt(item.quantity) + 1,
          };
        }

        return item;
      });
      setEditSubServices(updatedArray);
    } else if (value === "decrement") {
      const updatedArray = EditSubServices.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            quantity: parseInt(item.quantity) - 1,
          };
        }

        return item;
      });
      setEditSubServices(updatedArray);
    }
  }

  const calculateEditPriceforbooking = () => {
    var totalAmountvar = 0;
    var totalDurationvar = 0;
    EditSubServices.map((item) => {
      const basePrice = parseInt(item.base_price);
      const baseCount = 1;
      const baseDuration = parseInt(item.base_duration);
      const extraCount = parseInt(item.quantity) - baseCount;
      const extraPrice = parseInt(item.base_price_extra_unit);
      const extraDuration = parseInt(item.extra_duration_per_unit_in_minute);
      const baseAmount = basePrice * baseCount;
      const extraAmount = extraPrice * extraCount;
      totalAmountvar = totalAmountvar + baseAmount + extraAmount;
      totalDurationvar =
        totalDurationvar + baseDuration + extraCount * extraDuration;
    });
    editaddons.map((item) => {
      if (item.addons_service_qty == 0 || item.addons_service_qty == null) {
      } else {
        const basePrice = parseInt(item.base_price);
        const baseCount = 1;
        const baseDuration = parseInt(item.base_duration);
        const extraCount = parseInt(item.addons_service_qty) - baseCount;
        const extraPrice = parseInt(item.price_for_per_extra_unit);
        const extraDuration = parseInt(item.extra_minute_per_unit);
        const baseAmount = basePrice * baseCount;
        const extraAmount = extraPrice * extraCount;
        totalAmountvar = totalAmountvar + baseAmount + extraAmount;
        totalDurationvar =
          totalDurationvar + baseDuration + extraCount * extraDuration;
      }
    });
    setEditTotalAmount(totalAmountvar);
    const staff_length = assignStaff.length > 0 ? assignStaff.length : 1;
    // setEditTotalDuration(parseInt(totalDurationvar / staff_length));

    setEditTotalDuration(parseInt(totalDurationvar));

    //get percentage from totalAmount
    var Servicepercentage = parseInt(editbooking.service_percentage);
    const percentage = (totalAmountvar * Servicepercentage) / 100;
    const totalAmountvar1 = totalAmountvar + percentage;
    setEditbookingestimatedPrice(totalAmountvar1);

    if (editbooking.booking_discount > 0) {
      const discountvalue = totalAmountvar1 - editbooking.booking_discount;
      setEditbookingChangesAmount(discountvalue);
    } else {
      setEditbookingChangesAmount(totalAmountvar1);
    }

    //get percentage from totalDurationvar
    const extrarange = (totalDurationvar * Servicepercentage) / 100;
    const totalDurationvarwithextra = totalDurationvar + extrarange;
    // setEditbookingestimatedDuration(parseInt(totalDurationvarwithextra / staff_length));
    setEditbookingestimatedDuration(parseInt(totalDurationvarwithextra));
    setExpedtedendtime(parseInt(totalDurationvarwithextra / staff_length));
  };

  const UpdateBookigData = () => {
    if (EditbookingStartTime < "07:00" || EditbookingStartTime > "21:00") {
      NotificationManager.error(
        "⚠ Please select time between 07:00 AM to 08:00 PM"
      );
      return;
    }

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    formData.append("client_id", bookingDetails.client_id);
    formData.append("start_date", EditbookingStartDate);
    formData.append("start_d_time", EditbookingStartTime);
    formData.append("service_amount", Math.round(editbookingestimatedPrice));
    formData.append("duration", editbookingestimatedDuration);
    formData.append("appointment_note_by_staff", editbooking.appointment_note);
    formData.append("appointment_zip", editbooking.appointment_zip);
    formData.append("appointment_address", editbooking.client_address);
    formData.append("appointment_city", editbooking.appointment_city);
    formData.append("appointment_state", editbookingstate);
    formData.append("client_name", editbooking.client_name);

    formData.append("booking_discount", editbookingdiscount);
    const requestPayload = buildEditSpecialClientRequest(
      editBookingTime,
      editClientNotes,
      editHasCats,
      editHasDogs,
      editRequestedTechnician
    );
    if (requestPayload != null) {
      formData.append("request", requestPayload);
    }
    formData.append(
      "estimated_price",
      "$" +
      edittotalAmount +
      " to " +
      "$" +
      Math.round(editbookingestimatedPrice)
    );
    formData.append(
      "estimated_duration",
      convertToHHMM(editbaseTime) +
      " to " +
      convertToHHMM(editbookingestimatedDuration)
    );

    const subServices = [];
    for (let i = 0; i < EditSubServices.length; i++) {
      // subServices.push(EditSubServices[i].quantity);
      subServices.push({
        id: EditSubServices[i].booking_id,
        quantity: EditSubServices[i].quantity,
      });
    }
    formData.append("method_unit_selected_values", JSON.stringify(subServices));

    const staffIds = [];

    if (
      assignStaff != null &&
      assignStaff != "" &&
      assignStaff != undefined &&
      assignStaff.length > 0
    ) {
      for (let i = 0; i < assignStaff.length; i++) {
        staffIds.push(assignStaff[i].value);
      }
      formData.append("staff_ids", staffIds);
    } else {
      // const staffIds = [];

      // updatestaff.map((item) => {
      //   staffIds.push(item);
      // });

      formData.append("staff_ids", 79);
    }

    const addons = [];
    for (let i = 0; i < editaddons.length; i++) {
      addons.push({
        id: editaddons[i].id,
        quantity: editaddons[i].addons_service_qty,
        type: editaddons[i].new,
      });
    }
    formData.append("addons_service_qty", JSON.stringify(addons));

    updateBookingData(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking updated successfully");
            handleClose3();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        //console.log(error);
      })
      .finally(() => {
        setStartDate(EditbookingStartDate);
        onCloseidChangebooking(0);
        onCloseidChangeoldbookingid(bookingDetails.order_id);
      });
  };

  const [apicall, setApicall] = useState(false);

  const updaterecurringbooking = () => {
    if (EditbookingStartTime < "07:00" || EditbookingStartTime > "21:00") {
      NotificationManager.error(
        "⚠ Please select time between 07:00 AM to 08:00 PM"
      );
      return;
    }

    setApicall(true);
    const formData = new FormData();
    formData.append("recurring_id", bookingDetails.recurring_id);
    formData.append("client_id", bookingDetails.client_id);
    formData.append("start_date", EditbookingStartDate);
    formData.append("start_d_time", EditbookingStartTime);
    formData.append("service_amount", Math.round(editbookingestimatedPrice));
    formData.append("duration", editbookingestimatedDuration);
    formData.append("appointment_note_by_staff", editbooking.appointment_note);
    formData.append("appointment_zip", editbooking.appointment_zip);
    formData.append("appointment_address", editbooking.client_address);
    formData.append("appointment_city", editbooking.appointment_city);
    formData.append("appointment_state", editbookingstate);
    formData.append("client_name", editbooking.client_name);
    const requestPayload = buildEditSpecialClientRequest(
      editBookingTime,
      editClientNotes,
      editHasCats,
      editHasDogs,
      editRequestedTechnician
    );
    if (requestPayload != null) {
      formData.append("request", requestPayload);
    }
    formData.append(
      "estimated_price",
      "$" +
      edittotalAmount +
      " to " +
      "$" +
      Math.round(editbookingestimatedPrice)
    );
    formData.append(
      "estimated_duration",
      convertToHHMM(editbaseTime) +
      " to " +
      convertToHHMM(editbookingestimatedDuration)
    );

    const subServices = [];
    for (let i = 0; i < EditSubServices.length; i++) {
      // subServices.push(EditSubServices[i].quantity);
      subServices.push({
        id: EditSubServices[i].booking_id,
        method_id: EditSubServices[i].id,
        quantity: EditSubServices[i].quantity,
      });
    }
    formData.append("method_unit_selected_values", JSON.stringify(subServices));

    const staffIds = [];

    if (
      assignStaff != null &&
      assignStaff != "" &&
      assignStaff != undefined &&
      assignStaff.length > 0
    ) {
      for (let i = 0; i < assignStaff.length; i++) {
        staffIds.push(assignStaff[i].value);
      }
      formData.append("staff_ids", staffIds);
    } else {
      // const staffIds = [];

      // updatestaff.map((item) => {
      //   staffIds.push(item);
      // });

      formData.append("staff_ids", 79);
    }

    const addons = [];
    for (let i = 0; i < editaddons.length; i++) {
      addons.push({
        id: editaddons[i].addon_id,
        quantity: editaddons[i].addons_service_qty,
        type: editaddons[i].new,
      });
    }
    formData.append("addons_service_qty", JSON.stringify(addons));

    updaterecurringbookingAPi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking updated successfully");
            handleClose3();
            // handleClose3();
            handleClose2();
            setEventcount(eventcount + 1);
            window.location.reload();
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        //console.log(error);
      })
      .finally(() => {
        setApicall(false);
      });
  };

  const calculatePrice = () => {
    var totalAmountvar = 0;
    var totalDurationvar = 0;
    subService.map((item) => {
      const basePrice = parseInt(item.base_price);
      const baseCount = 1;
      const baseDuration = parseInt(item.base_duration);
      const extraCount = item.quantity - baseCount;
      const extraPrice = parseInt(item.base_price_extra_unit);
      const extraDuration = parseInt(item.extra_duration_per_unit_in_minute);
      const baseAmount = basePrice * baseCount;
      const extraAmount = extraPrice * extraCount;
      totalAmountvar = totalAmountvar + baseAmount + extraAmount;
      totalDurationvar =
        totalDurationvar + baseDuration + extraCount * extraDuration;
    });
    addons.map((item) => {
      if (item.quantity == 0) {
      } else {
        const basePrice = parseInt(item.base_price);
        const baseCount = 1;
        const baseDuration = parseInt(item.base_duration);
        const extraCount = item.quantity - baseCount;
        const extraPrice = parseInt(item.price_for_per_extra_unit);
        const extraDuration = parseInt(item.extra_minute_per_unit);
        const baseAmount = basePrice * baseCount;
        const extraAmount = extraPrice * extraCount;
        totalAmountvar = totalAmountvar + baseAmount + extraAmount;
        totalDurationvar =
          totalDurationvar + baseDuration + extraCount * extraDuration;
      }
    });

    setTotalAmount(totalAmountvar);
    setTotalDuration(parseInt(totalDurationvar));
    // setTotalDuration(parseInt(totalDurationvar / ChooseStaff.length));

    //get percentage from totalAmount
    const percentage = (totalAmountvar * servicepercentage) / 100;
    const totalAmountvar1 = totalAmountvar + percentage;
    setExpectedTotalAmount(totalAmountvar1);

    //get percentage from totalDurationvar
    const extrarange = (totalDurationvar * servicepercentage) / 100;
    const totalDurationvarwithextra = totalDurationvar + extrarange;

    setBasewithextra(parseInt(totalDurationvarwithextra));
    setUpdatedendtime(parseInt(totalDurationvarwithextra));
  };

  const confirmbooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to confirm this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    confirmbookingstatusFSR(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            notify.success("Booking confirmed successfully");
            handleClose2();
            setEventcount(eventcount + 1);
            // getbookingsfunc();
            // window.location.reload();
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const rejectbooking = () => {
    if (window.confirm("Are you sure you want to reject this booking?")) {
      const formData = new FormData();
      formData.append("order_id", bookingDetails.order_id);
      rejectbookingstatus(formData)
        .then((response) => {
          if (response.code === 200) {
            if (response.data.status === "1") {
              // alert("Booking remove successfully");
              // handleClose4();
              setEventcount(eventcount + 1);
              // window.location.reload();
            } else {
              notify.error("Something went wrong");
            }
          } else {
            notify.error("Something went wrong");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [addClasss, setAddClasss] = useState(false);
  const [addRecurringClasss, setAddRecurringClasss] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelReasonError, setCancelReasonError] = useState("");
  const [cancelRecurringReason, setCancelRecurringReason] = useState("");
  const [cancelRecurringReasonError, setCancelRecurringReasonError] = useState("");
  const [cancelLoader, setCancelLoader] = useState(false);

  const cancelbookingbyidadmins = () => {
    if (!cancelReason || cancelReason.trim() === "") {
      setCancelReasonError("Please provide a reason for cancellation");
      return;
    }
    setCancelReasonError("");
    setCancelLoader(true);
    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    formData.append("notes", cancelReason.trim());
    formData.append("booking_date_time", bookingDetails.appointment_starttime);
    cancelbookingbyidadmin(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            NotificationManager.success("Booking cancelled successfully");
            handleClose2();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setCancelLoader(false);
        setAddClasss(false);
        setCancelReason("");
        setCancelReasonError("");
      });
  };

  const cancelreccuringbooking = () => {
    if (!cancelRecurringReason || cancelRecurringReason.trim() === "") {
      setCancelRecurringReasonError("Please provide a reason for cancellation");
      return;
    }
    setCancelRecurringReasonError("");
    setCancelLoader(true);
    const formData = new FormData();
    formData.append("recurring_id", bookingDetails.recurring_id);
    formData.append(
      "booking_date",
      bookingDetails.appointment_starttime_test
    );
    formData.append("reject_reason", cancelRecurringReason.trim());
    formData.append("order_id", bookingDetails.order_id);
    reccuringcancelbooking(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            NotificationManager.success("Booking cancelled successfully");
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setCancelLoader(false);
        setAddRecurringClasss(false);
        setCancelRecurringReason("");
        setCancelRecurringReasonError("");
      });
  };

  const [rescheduleDetails, setRescheduleDetails] = useState([]);
  const [selectstaffs, setSelectstaffs] = useState([]);
  const [rescheduleDate, setRescheduleDate] = useState(
    rescheduleDetails.order_date
  );
  const [reschedunotes, setReschedulenotes] = useState(
    rescheduleDetails.order_time
  );

  useEffect(() => { }, [selectstaffs]);

  useEffect(() => {
    setRescheduleDate(rescheduleDetails.order_date);
    setReschedulenotes(rescheduleDetails.app_notes);
  }, [rescheduleDetails]);

  useEffect(() => {
    // setSelectstaffs(rescheduleDetails.staff_ids);
    //set select staff ids in array
    const staff_ids = rescheduleDetails.staff_ids;
    if (staff_ids > 0) {
      const staff_ids_array = staff_ids.split(",");
      const staff_ids_index = [];
      staff_ids_array.forEach((staff_id) => {
        const index = staffList.findIndex((staff) => staff.value === staff_id);
        staff_ids_index.push(index);
      });
      const selectedStaff = [];
      staff_ids_index.forEach((index) => {
        selectedStaff.push(staffList[index]);
      });
      setSelectstaffs(selectedStaff);
    }
  }, [rescheduleDetails]);

  const rescheduleData = () => {
    handleShow5();

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);

    getrescheduledata(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setRescheduleDetails(response.data.data);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [startDate, setStartDate] = useState(
    moment(dateData).format("YYYY-MM-DD")
  );
  const [changestaffzone, setchangesstaffzone] = useState("");
  const [staffListtttt, setStaffListtttt] = useState(null);

  useEffect(() => {
    getStaffListtt();
  }, [changestaffzone]);

  const getStaffListtt = () => {
    getStaff(changestaffzone)
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;
          if (res.data.status === "1") {
            setStaffListtttt(apiResponse.data);
          } else {
            notify.error("data not found");
            setStaffListtttt([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [Frequency, setFrequency] = useState([]);

  const [CustomWeekmonth, setCustomWeekmonth] = useState([]);
  const [CustomWeeksmonths, setCustomWeeksmonths] = useState([]);

  useEffect(() => {
    if (CustomWeeksmonths === "weeks") {
      document.getElementById("my_time_week1").style.display = "block";
      document.getElementById("my_time_week2").style.display = "none";
    }
    if (CustomWeeksmonths === "months") {
      document.getElementById("my_time_week2").style.display = "block";
      document.getElementById("my_time_week1").style.display = "none";
    }
  }, [CustomWeeksmonths]);

  useEffect(() => {
    if (Frequency === "weekly") {
      document.getElementById("weekly").style.display = "block";
      document.getElementById("monthly").style.display = "none";
      document.getElementById("custom").style.display = "none";
      document.getElementById("hide-sec").style.display = "none";
      setSummary([]);
      setCustomWeekmonth([]);
    }
    if (Frequency === "monthly") {
      document.getElementById("monthly").style.display = "block";
      document.getElementById("weekly").style.display = "none";
      document.getElementById("custom").style.display = "none";
      document.getElementById("hide-sec").style.display = "none";
      setSummary([]);
      setCustomWeekmonth([]);
    }
    if (Frequency === "0") {
      document.getElementById("monthly").style.display = "none";
      document.getElementById("weekly").style.display = "none";
      document.getElementById("custom").style.display = "none";
      document.getElementById("hide-sec").style.display = "none";
      setSummary([]);
      setCustomWeekmonth([]);
    }
    if (Frequency === "custom") {
      document.getElementById("custom").style.display = "block";
      document.getElementById("monthly").style.display = "none";
      document.getElementById("weekly").style.display = "none";
      document.getElementById("hide-sec").style.display = "none";
      setSummary([]);
      setCustomWeekmonth([]);
    }
  }, [Frequency]);

  const [summary, setSummary] = useState([]);
  const [bookingStartDate, setBookingStartDate] = useState(null);
  const [bookingEndDate, setBookingEndDate] = useState(null);
  const [recurringbookingdate, setRecurringbookingdate] = useState(null);

  const [selectedDays, setSelectedDays] = useState([]);

  useEffect(() => {
    if (selectedDays.length > 0) {
      let data = new FormData();
      data.append("selectedDays", JSON.stringify(selectedDays));
      getDates(data)
        .then((response) => {
          if (response.code === 200) {
            if (response.data.status === "1") {
              const apiResponse = response.data.data;
              apiResponse.map((item, index) => {
                if (index === 0) {
                  setBookingStartDate(item);
                }
                if (index === response.data.data.length - 1) {
                  setBookingEndDate(item);
                }
              });

              setRecurringbookingdate(response.data.data);
            } else {
              console.log("response: error");
            }
          } else {
            console.log("response: error");
          }
        })
        .catch((error) => {
          console.log("response: error");
        });
    }
  }, [selectedDays]);

  const [customedateobj, setCustomedateobj] = useState([]);
  const [bookingzonelist, setBookingzonelist] = useState([]);

  useEffect(() => {
    if (customedateobj.length > 0) {
      let data = new FormData();
      data.append("selectedDays", JSON.stringify(customedateobj));
      getDates(data)
        .then((response) => {
          if (response.code === 200) {
            if (response.data.status === "1") {
              const apiResponse = response.data.data;

              apiResponse.map((item, index) => {
                if (index === 0) {
                  setBookingStartDate(item);
                }
                if (index === response.data.data.length - 1) {
                  setBookingEndDate(item);
                }
              });

              setRecurringbookingdate(response.data.data);
            } else {
              console.log("response: error");
            }
          } else {
            console.log("response: error");
          }
        })
        .catch((error) => {
          console.log("response: error");
        });
    }
  }, [customedateobj]);

  useEffect(() => {
    getallzone();
  }, []);

  const getallzone = () => {
    getZone()
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setBookingzonelist(response.data.data);
          } else {
            console.log("response: error");
          }
        } else {
          console.log("response: error");
        }
      })
      .catch((error) => {
        console.log("response: error");
      });
  };

  const [cardNumber, setCardNumber] = useState("");
  const [cardExpDate, setCardExpDate] = useState("");
  const [cardCVV, setCardCVV] = useState("");
  const [fullName, setFullName] = useState("");

  const { getExpiryDateProps } = usePaymentInputs();

  const [cardNumbererror, setCardNumbererror] = useState(false);
  const [cardCVVerror, setCardCVVerror] = useState(false);
  const [cardExpDateerror, setCardExpDateerror] = useState(false);
  const [fullNamerror, setFullNamerror] = useState(false);
  const [cardExpYearerror, setCardExpYearerror] = useState(false);

  const handleAddCard = () => {
    const num = digitsOnly(cardNumber);
    if (num == "" || num.length != 16) {
      setCardNumbererror(true);
    } else {
      setCardNumbererror(false);
    }

    if (cardCVV == "" || cardCVV.length != 3) {
      setCardCVVerror(true);
    } else {
      setCardCVVerror(false);
    }

    if (cardExpDate == "") {
      setCardExpDateerror(true);
    }

    if (fullName == "") {
      setFullNamerror(true);
    } else {
      setFullNamerror(false);
    }

    const expDateParts = cardExpDate.split("/");

    const expMonth = parseInt(expDateParts[0]);
    const expYear = parseInt(expDateParts[1]);

    const currentMonth = new Date().getMonth() + 1; // Month is 0-indexed, so add 1
    const currentYear = new Date().getFullYear() % 100; // Get the last two digits of the current year

    if (
      expYear < currentYear ||
      (expYear === currentYear && expMonth < currentMonth)
    ) {
      // alert("Card expiration date should be in the future.");
      setCardExpYearerror(true);
      return;
    } else {
      setCardExpYearerror(false);
    }

    const name = fullName.split(" ");
    if (name.length < 2) {
      setFullNamerror(true);
      return;
    } else {
      setFullNamerror(false);
    }

    const formData = new FormData();
    formData.append("customer_id", bookingDetails.customer_id);
    formData.append("card_number", num);
    formData.append("person_name", fullName);
    formData.append("card_cvv", cardCVV);
    formData.append("card_exp", cardExpDate);

    createPaymentMethod(formData)
      .then((res) => {
        if (res.code === 200) {
          // alert("credentials added successfully");
           if (res.data.status == "1") {
            handleClose6();
            NotificationManager.success(res?.data?.message);
          }
          else {
            NotificationManager.error(res?.data?.message || "Something went wrong");
          }
        } else {
          NotificationManager.error("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const complatebooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to complete this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    complatebookingstatus(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking completed successfully");
            // getbookingsfunc();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const disuncnfcomplatebooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to complete this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    disuncnfcomplatebookingstatus(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking completed successfully");
            // getbookingsfunc();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const uncomplatebooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to uncomplete this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    uncomplatebookingstatus(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking uncompleted successfully");
            // getbookingsfunc();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const unconfirmbooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to unconfirm this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    unconfirmbookingstatus(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking unconfirmed successfully");
            // getbookingsfunc();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const activebooking = async () => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to active this booking?"
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    activebookingstatus(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking active successfully");
            // getbookingsfunc();
            handleClose2();
            // window.location.reload();
            setEventcount(eventcount + 1);
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createStaxId = () => {
    const formData = new FormData();
    formData.append("client_name", bookingDetails.client_name);
    formData.append("client_id", bookingDetails.client_id);
    formData.append("client_phone", bookingDetails.client_phone);
    formData.append("client_address", bookingDetails.client_address);
    formData.append("clientemail", bookingDetails.client_email);

    createStaxIdApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            NotificationManager.success("Stax Id created successfully");
            //get today booking
            window.location.reload();
            // getbookingsfunc();
            // handleClose2();
          } else {
            NotificationManager.error(response.data.message);
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [invoiceprice, setInvoiceprice] = useState();
  const [invoicenotes, setInvoicenotes] = useState("");
  const [invoiceservice, setInvoiceservice] = useState([]);

  const [cleaningtime, setCleaningTime] = useState();
  const [bookingtimesheetcleaningtime, setBookingtimesheetcleaningtime] =
    useState();
  const [bookingtimenote, setBookingtimenote] = useState();

  const getStatus = (status) => {
    if (status === "0") {
      return "(Admin Booked)";
    }
    if (status === "1") {
      return "(Client Booked)";
    }
    if (status === "2") {
      return "(Technician Booked)";
    }
  };

  const getsubserviceaddons = () => {
    const formData = new FormData();
    formData.append("order_id", bookingDetails.order_id);
    getsubserviceaddonsApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setInvoiceservice(response.data.data);

            handleShow4();
          } else {
            notify.error("Something went wrong");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [invoiceList, setInvoiceList] = useState([]);

  //invoice loader state
  const [invoiceLoader, setInvoiceLoader] = useState(false);

  const getinvoice = () => {
    // setLoading(true);
    setInvoiceLoader(true);
    const customer_id = bookingDetails.order_id;
    getinvoiceApi(customer_id)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            setInvoiceList(response.data.data);
          } else {
            setInvoiceList([]);
            NotificationManager.info("No invoice found");
          }
        } else {
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        // setLoading(false);
        setInvoiceLoader(false);
      });
  };

  const sendinvoicetouser = () => {
    console.log("edituser 2", bookingDetails);
  };

  const [keywords, setKeywords] = useState("");

  const handleChange = (e) => {
    setKeywords(e.target.value);
  };

  const [showModal7, setShowModal] = useState(false);

  const handleClose7 = () => setShowModal(false);
  const handleShow7 = () => setShowModal(true);

  const [selectedCard, setSelectedCard] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);

  const [paymentMethodId, setPaymentMethodId] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [invoicetotal, setInvoicetotal] = useState("");
  const [invoicestatus, setInvoicestatus] = useState("");

  const getpaymentCards = (id, total, status) => {
    setShowModal(true);
    setInvoiceId(id);
    setInvoicetotal(total);
    setInvoicestatus(status);
    const formData = new FormData();
    formData.append("customer_id", bookingDetails.customer_id);

    getpaymentMethod(formData)
      .then((res) => {
        if (res.code == 200) {
          if (res.data.status === "1") {
            const paymentMethod = res.data.data;
            setPaymentMethod(paymentMethod);
            if (paymentMethod && paymentMethod.length != 0 && !selectedCard) {
              if (bookingDetails.card_id != null) {
                const selectedPaymentMethod = paymentMethod.find(
                  (item) => item.id === bookingDetails.card_id
                );
                if (selectedPaymentMethod) {
                  setPaymentMethodId(selectedPaymentMethod.id);
                  setSelectedCard(`cardOption${selectedPaymentMethod.id}`);
                }
              } else {
                setSelectedCard(`cardOption${paymentMethod[0].id}`);
                setPaymentMethodId(paymentMethod[0].id);
              }
            }
          } else {
            notify.warning("Please Add card first");
            handleClose7();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [payloader, setPayLoader] = useState(false);

  const payinvoice = () => {
    setPayLoader(true);

    const payments = bookingDetails?.payments;

    // Ensure parsedPayments is a valid array
    const parsedPayments = payments ? JSON.parse(payments) : [];

    // Check if parsedPayments is an array and proceed with the logic
    if (Array.isArray(parsedPayments)) {
      const currentTime = new Date();

      // Use find() to search for the specific invoiceId
      const existingPayment = parsedPayments.find(
        (payment) => payment.invoiceId === invoiceId
      );

      if (existingPayment) {
        const paymentTime = new Date(existingPayment.currenttimedate);
        const timeDiff = (currentTime - paymentTime) / (1000 * 60); // Time difference in minutes

        // If the time difference is less than 5 minutes, show alert
        if (timeDiff < 5) {
          notify.warning("Please try again after 5 minutes.");
          return; // Stop the function execution if payment was recent
        }
      }
    }

    const formData = new FormData();
    formData.append("payment_method_id", paymentMethodId);
    formData.append("apply_balance", invoicetotal);
    formData.append("invoiceId", invoiceId);
    formData.append("order_id", bookingDetails.order_id);
    formData.append("invoicestatus", invoicestatus);

    payinvoiceApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            const status = response.data.data.status;
            if (status === "DRAFT" || status === "PENDING") {
              NotificationManager.error(
                "Your invoice payment was unsuccessful. Try again"
              );
            } else {
              if (
                response &&
                response.data &&
                response.data.data &&
                response.data.data.status
              ) {
                const messages =
                  "YOUR INVOICE" + " " + response.data.data.status;
                // if (messages) {

                //   getinvoice();
                // } else {
                //   NotificationManager.success("Your invoice has been paid");
                //   getinvoice();
                // }
                NotificationManager.success(messages);
                getinvoice();
              } else {
                if (
                  response.data.data &&
                  Array.isArray(response.data.data.payment_method_id) &&
                  response.data.data.payment_method_id.length > 0
                ) {
                  // NotificationManager.error(response.data.data.payment_method_id[0]);
                  NotificationManager.info(
                    "Your invoice payment was attempted but failed. Please try again after 5 minutes.*"
                  );
                } else {
                  NotificationManager.error(
                    "didnot get invoice status from stax, Please refresh after 10 seconds"
                  );
                }
                getinvoice();
              }
            }
            setPayLoader(false);
          } else {
            notify.error("Something went wrong");
            setPayLoader(false);
          }
        } else {
          notify.error("Something went wrong");
          setPayLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setPayLoader(false);
      })
      .finally(() => {
        // setPaymentMethodId('');
        handleClose7();
      });
  };

  const states = [
    {
      name: "Alabama",
      cities: ["Birmingham", "Montgomery", "Mobile"],
      stateCode: "AL",
    },
    {
      name: "Alaska",
      cities: ["Anchorage", "Fairbanks", "Juneau"],
      stateCode: "AK",
    },
    { name: "Arizona", cities: ["Phoenix", "Tucson", "Mesa"], stateCode: "AZ" },
    {
      name: "Arkansas",
      cities: ["Little Rock", "Fort Smith", "Fayetteville"],
      stateCode: "AR",
    },
    {
      name: "California",
      cities: ["Los Angeles", "San Diego", "San Jose"],
      stateCode: "CA",
    },
    {
      name: "Colorado",
      cities: ["Denver", "Colorado Springs", "Aurora"],
      stateCode: "CO",
    },
    {
      name: "Connecticut",
      cities: ["Bridgeport", "New Haven", "Hartford"],
      stateCode: "CT",
    },
    {
      name: "Delaware",
      cities: ["Wilmington", "Dover", "Newark"],
      stateCode: "DE",
    },
    {
      name: "Florida",
      cities: ["Jacksonville", "Miami", "Tampa"],
      stateCode: "FL",
    },
    {
      name: "Georgia",
      cities: ["Atlanta", "Augusta", "Columbus"],
      stateCode: "GA",
    },
    {
      name: "Hawaii",
      cities: ["Honolulu", "Pearl City", "Hilo"],
      stateCode: "HI",
    },
    { name: "Idaho", cities: ["Boise", "Nampa", "Meridian"], stateCode: "ID" },
    {
      name: "Illinois",
      cities: ["Chicago", "Aurora", "Rockford"],
      stateCode: "IL",
    },
    {
      name: "Indiana",
      cities: ["Indianapolis", "Fort Wayne", "Evansville"],
      stateCode: "IN",
    },
    {
      name: "Iowa",
      cities: ["Des Moines", "Cedar Rapids", "Davenport"],
      stateCode: "IA",
    },
    {
      name: "Kansas",
      cities: ["Wichita", "Overland Park", "Kansas City"],
      stateCode: "KS",
    },
    {
      name: "Kentucky",
      cities: ["Louisville", "Lexington", "Bowling Green"],
      stateCode: "KY",
    },
    {
      name: "Louisiana",
      cities: ["New Orleans", "Baton Rouge", "Shreveport"],
      stateCode: "LA",
    },
    {
      name: "Maine",
      cities: ["Portland", "Lewiston", "Bangor"],
      stateCode: "ME",
    },
    {
      name: "Maryland",
      cities: ["Baltimore", "Frederick", "Rockville"],
      stateCode: "MD",
    },
    {
      name: "Massachusetts",
      cities: ["Boston", "Worcester", "Springfield"],
      stateCode: "MA",
    },
    {
      name: "Michigan",
      cities: ["Detroit", "Grand Rapids", "Warren"],
      stateCode: "MI",
    },
    {
      name: "Minnesota",
      cities: ["Minneapolis", "Saint Paul", "Rochester"],
      stateCode: "MN",
    },
    {
      name: "Mississippi",
      cities: ["Jackson", "Gulfport", "Southaven"],
      stateCode: "MS",
    },
    {
      name: "Missouri",
      cities: ["Kansas City", "Saint Louis", "Springfield"],
      stateCode: "MO",
    },
    {
      name: "Montana",
      cities: ["Billings", "Missoula", "Great Falls"],
      stateCode: "MT",
    },
    {
      name: "Nebraska",
      cities: ["Omaha", "Lincoln", "Bellevue"],
      stateCode: "NE",
    },
    {
      name: "Nevada",
      cities: ["Las Vegas", "Henderson", "Reno"],
      stateCode: "NV",
    },
    {
      name: "New Hampshire",
      cities: ["Manchester", "Nashua", "Concord"],
      stateCode: "NH",
    },
    {
      name: "New Jersey",
      cities: ["Newark", "Jersey City", "Paterson"],
      stateCode: "NJ",
    },
    {
      name: "New Mexico",
      cities: ["Albuquerque", "Las Cruces", "Rio Rancho"],
      stateCode: "NM",
    },
    {
      name: "New York",
      cities: ["New York", "Buffalo", "Rochester"],
      stateCode: "NY",
    },
    {
      name: "North Carolina",
      cities: ["Charlotte", "Raleigh", "Greensboro"],
      stateCode: "NC",
    },
    {
      name: "North Dakota",
      cities: ["Fargo", "Bismarck", "Grand Forks"],
      stateCode: "ND",
    },
    {
      name: "Ohio",
      cities: ["Columbus", "Cleveland", "Cincinnati"],
      stateCode: "OH",
    },
    {
      name: "Oklahoma",
      cities: ["Oklahoma City", "Tulsa", "Norman"],
      stateCode: "OK",
    },
    {
      name: "Oregon",
      cities: ["Portland", "Salem", "Eugene"],
      stateCode: "OR",
    },
  ];

  const [servicepreferences, setServicepreferences] = useState([]);

  useEffect(() => {
    getservicesforuser();
  }, [edituser]);

  const getservicesforuser = () => {
    const formData = new FormData();
    formData.append("user_id", edituser.id);
    getbookingservicesApi(formData).then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        setServicepreferences(apiResponse.data);
      } else {
        notify.error("Something went wrong");
      }
    });
  };

  const getscheduledtime = (booking_duration, staff_ids, order_date) => {
    if (
      booking_duration != "" &&
      booking_duration != null &&
      staff_ids != "" &&
      staff_ids != null
    ) {
      // Extract hours and minutes from booking_duration
      const durationParts = booking_duration.split(" ");
      const hours = parseInt(durationParts[0]);
      const minutes = parseInt(durationParts[2]);

      // Calculate total duration in minutes
      const totalMinutes = hours * 60 + minutes;

      //check order_date is less than and equal to today
      // const today = "2024-01-29";
      // const date = new Date(order_date);
      // if (date <= today) {
      //   return `${hours} hours ${minutes} minutes`;
      // }
      // else {
      const staffIdsArray = staff_ids.split(",");

      const resultHours = Math.floor(totalMinutes / staffIdsArray.length / 60);
      const resultMinutes = (totalMinutes / staffIdsArray.length) % 60;

      return `${resultHours} hours ${parseInt(resultMinutes)} minutes`;
      // }
    }
  };

  const gettechnicialtime = (booking_timesheet_cleaning_time) => {
    if (
      Array.isArray(booking_timesheet_cleaning_time) &&
      booking_timesheet_cleaning_time.length > 0
    ) {
      const formattedNotes = booking_timesheet_cleaning_time.map(
        (item) =>
          `${item.fullname} notes: ${convertToHHMM(item.time_difference)}`
      );
      return formattedNotes.join(", ");
    }
  };

  const gettechtimesheetnotes = (bookingNotes) => {
    if (Array.isArray(bookingNotes) && bookingNotes.length > 0) {
      const formattedNotes = bookingNotes.map(
        (item) => `${item.fullname} notes: ${item.note}`
      );
      return formattedNotes.join(", ");
    }
  };

  const getdividetime = (startTime, booking_duration, staff_ids) => {
    if (
      booking_duration != "" &&
      booking_duration != null &&
      staff_ids != "" &&
      staff_ids != null
    ) {
      const durationParts = booking_duration.split(" ");
      const hours = parseInt(durationParts[0]);
      const minutes = parseInt(durationParts[2]);

      const totalMinutes = hours * 60 + minutes;

      const numStaff = staff_ids.split(",").length;
      const timePerStaff = totalMinutes / numStaff;

      const hoursPerStaff = Math.floor(timePerStaff / 60)
        .toString()
        .padStart(2, "0");

      //i want to time like 01:45
      const minutesPerStaff = (timePerStaff % 60).toString().padStart(2, "0");

      const date = moment(startTime, "HH:mm:ss");

      return moment(date)
        .add(hoursPerStaff, "hours")
        .add(minutesPerStaff, "minutes")
        .format("HH:mm");
    }
  };

  const [editbookingtimeEnd, setEditbookingtimeEnd] = useState("");

  useEffect(() => {
    getCalculatedEndTime(editbooking.start_time, expedtedendtime);
  }, [editbooking.start_time, expedtedendtime]);

  function getCalculatedEndTime(starttime, endtimeInMinutes) {
    const startMoment = moment(starttime, "hh:mm A");
    const endMoment = startMoment.clone().add(endtimeInMinutes, "minutes");

    // Format the result as "HH:mm"
    const formattedEndTime = endMoment.format("HH:mm");

    // return formattedEndTime;
    setEditbookingtimeEnd(formattedEndTime);
  }

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    setEditbookingStartTime(newStartTime);

    const startMoment = moment(newStartTime, "hh:mm A");
    const endMoment = startMoment.clone().add(expedtedendtime, "minutes");

    const formattedEndTime = endMoment.format("HH:mm");
    setEditbookingtimeEnd(formattedEndTime);
  };

  const [usercrmid, setUsercrmid] = useState(0);

  const callChildFunction = (userid) => {
    setUsercrmid(userid);
  };

  const [rows, setRows] = useState([
    {
      id: "",
      service: "",
      notes: "",
      quantity: 1,
      price: 0,
    },
  ]);

  useEffect(() => {
    const booking_discount = bookingDetails.booking_discount;

    const getServiceName = () => {
      const serviceType = bookingDetails.service_title.replace(":", "").trim();
      const customerStage = bookingDetails.customer_stage;
      // if (
      //   serviceType === "Deluxe First Time Cleaning" ||
      //   serviceType === "General First Time Cleaning"
      // ) {
      //   return "First Time Cleaning";
      // }

      // if (serviceType === "House Cleaning") {
      //   if (customerStage === "Maturing") {
      //     return "Scheduled Cleaning";
      //   } else {
      //     return "Regular Cleaning";
      //   }
      // }
      if (customerStage === "Maturing") {
          return "Scheduled Cleaning";
      }
      if (customerStage === "Booked 1st") {
          return "First Time Cleaning";
      }
      if (["Booked 2nd", "Booked 3rd", "Irregular", "Innactive"].includes(customerStage)) {
          return "Regular Cleaning";
      }
      // Default
      return "Regular Cleaning";
    };

    if (Array.isArray(bookingtimesheetcleaningtime)) {
      const hourly_rate = parseInt(bookingDetails.hourly_rate);
      const base_price = parseInt(bookingDetails.base_price);
      const service = getServiceName();

      // Main staff rows
      const updatedRows = bookingtimesheetcleaningtime.map((staff, index) => {
        return {
          id: bookingDetails.service_stax_id,
          service: service, // use the new logic here
          notes: staff.fullname,
          quantity: convertToHM(staff.time_difference),
          price: hourly_rate,
          total: hourly_rate * convertToHM(staff.time_difference),
        };
      });

      // Base fee row
      const rowobject2 = {
        id: bookingDetails.service_stax_id,
        service: service, // use the new logic here
        notes: "Base Fee",
        quantity: 1,
        price: base_price,
        total: base_price,
      };

      let updatedRowsWithRowObject2 = [...updatedRows, rowobject2];

      // Discount row (if applicable)
      const { coupon_type, coupon_value } = bookingDetails;
      let discount = 0;
      if (coupon_type == "1") {
        discount = (base_price * coupon_value) / 100;
      } else {
        if (coupon_type == "") {
          discount = booking_discount;
        } else {
          discount = coupon_value;
        }
      }

      // Discount row (if applicable)
      if (
        booking_discount !== undefined &&
        booking_discount > 0 &&
        booking_discount !== null
      ) {
        const rowobject3 = {
          id: "ace0d202-c9dc-4bef-821d-62ef309ffe2b",
          service: "Discounts",
          notes: "",
          quantity: 1,
          price: -discount,
          total: -discount,
        };
        updatedRowsWithRowObject2.push(rowobject3);
      }
      setRows(updatedRowsWithRowObject2);
    } else {
      setRows([
        {
          service: "",
          notes: "",
          quantity: 1,
          price: 0,
        },
      ]);
    }
  }, [bookingtimesheetcleaningtime]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        service: "",
        notes: "",
        quantity: 0,
        price: 0,
      },
    ]);
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const removeRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  function convertToHM(value) {
    const start_time = value;
    const hours = Math.floor(start_time / 60);
    const minutes = start_time % 60;

    // Calculate the total time in hours with decimal representation for minutes
    const totalHours = hours + minutes / 60;

    return totalHours;
  }

  const [productlist, setproductlist] = useState([]);

  const [discountinvoice, setDiscountinoice] = useState(0);

  const productlistdata = () => {
    getproductlistdataApi().then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data.data;
        setproductlist(apiResponse);
      } else {
        notify.error("Something went wrong");
      }
    });
  };

  const defaultServiceValue = (() => {
    // if (!bookingDetails?.customer_stage || productlist.length === 0) return "";

    const stage = bookingDetails.customer_stage;

    let category = "";

    if (stage === "Maturing") category = "Scheduled Cleaning";
    else if (stage === "Booked 1st") category = "First Time Cleaning";
    else if (["Booked 2nd", "Booked 3rd", "Irregular", "Innactive"].includes(stage))
      category = "Regular Cleaning";
    else category = "Regular Cleaning";

    const matched = productlist.find(
      (item) =>
        Boolean(item?.is_service) && item.item?.trim() === category
    );
    //return matched ? ${matched.id}**${matched.item} : "";
    return matched ? matched.id : "";
  })();

  const createinvoice = () => {
    setInvoiceLoaderNew(true);
    if (invoicenotes == "") {
      notify.warning("Please enter invoice notes");
      setInvoiceLoaderNew(false);
      return false;
    }

    const formData = new FormData();
    var totalprice = 0;

    const lineItems = [];

    for (let i = 0; i < rows.length; i++) {
      const serviceParts = rows[i].service.split(" ");
      let serviceName;
      if (serviceParts[0].length === 36 && serviceParts[0].includes("-")) {
        serviceName = serviceParts.slice(1).join(" ");
      } else {
        serviceName = rows[i].service;
      }

      const data = {
        id: rows[i].id || serviceParts[0],
        item: serviceName,
        details: rows[i].notes,
        quantity: parseFloat(rows[i].quantity, 10),
        price: parseFloat(rows[i].price),
      };
      lineItems.push(data);

      totalprice += data.quantity * data.price;
    }

    formData.append("customer_id", bookingDetails.customer_id);
    formData.append("user_id", bookingDetails.client_id);
    formData.append("total", calculateTotal(rows, discountinvoice));
    formData.append("subtotal", calculateTotal(rows, discountinvoice));
    // formData.append("notes", invoicenotes);
    formData.append("order_id", bookingDetails.order_id);
    formData.append("booking_date_time", bookingDetails.appointment_starttime);

    formData.append("line_item", JSON.stringify(lineItems));

    createinvoiceApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            NotificationManager.success("Invoice created successfully");
            setInvoiceLoaderNew(false);
            getinvoice();
          } else {
            setInvoiceLoaderNew(false);
            NotificationManager.error(response.data.message);
          }
        } else {
          setInvoiceLoaderNew(false);
          notify.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCardNumberChange = (event) => {
    let { value, name } = event.target;
    let cardNumber = value;
    value = value.replace(/\D/g, "");
    if (/^3[47]\d{0,13}$/.test(value)) {
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
      // diner's club, 14 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^\d{0,16}$/.test(value)) {
      // regular cc number, 16 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
        .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
    }

    setCardNumber(cardNumber.trimRight());
  };

  const addClass = () => {
    // document.querySelector(".view-more-content-hide").classList.add("active");
    // document.querySelector(".less-btn").classList.add("active");
    // document.querySelector(".more-btn").classList.add("active");
    // setCollapse(!collapse);
  };

  const removeClass = () => {
    // document
    //   .querySelector(".view-more-content-hide")
    //   .classList.remove("active");
    // document.querySelector(".less-btn").classList.remove("active");
    // document.querySelector(".more-btn").classList.remove("active");
    // setCollapse(!collapse);
  };

  const [multipleemailmsg, setMultipleemailmsg] = useState(false);
  const [emailmsg, setEmailmsg] = useState(false);
  const [staxaccount, setStaxAccount] = useState(false);

  const [invoiceLoaderNew, setInvoiceLoaderNew] = useState(false);
  const [invoicepoploader, setInvoicePoploader] = useState(false);
  const [staxloader, setStaxLoader] = useState(false);
  const [staxData, setStaxData] = useState([]);

  const getstaxaccountfunc = () => {
    setStaxLoader(true);
    const formData = new FormData();
    const client_email = bookingDetails.client_email
      .replace(/[:\s]/g, "")
      .trim();
    formData.append("email", client_email);

    getstaxaccount(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status === 1) {
            const apiResponse = res.data.data.data;
            setStaxData(apiResponse);
            if (apiResponse && apiResponse.length > 0) {
              const emailcount = apiResponse.length;
              if (emailcount > 1) {
                setMultipleemailmsg(true);
              } else if (emailcount === 1) {
                const staxApi = apiResponse[0].id;
                if (bookingDetails.customer_id !== staxApi) {
                  setEmailmsg(true);
                }
              } else {
                setEmailmsg(false);
                setMultipleemailmsg(false);
              }
            } else {
              setStaxAccount(true);
            }
            // setstaxaccount(apiResponse.data);
            handleShow4();
          } else {
            console.log("Something went wrong");
          }
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setStaxLoader(false);
      });
  };

  const columns = [
    {
      dataField: "id",
      text: "Id",
      formatter: (cell, row, rowIndex, formatExtraData) => (
        <div>{rowIndex + 1}</div>
      ),
      sort: true,
    },
    {
      dataField: "id",
      text: "INVOICE ID",
      formatter: (cell, row) => (
        <>
          <a
            href={`https://app.staxpayments.com/#/bill/${row.id}`}
            target="_blank"
          >
            {cell}
          </a>

          <div>Stax id: {row.customer_id}</div>
        </>
      ),
      sort: true,
    },
    {
      dataField: "created_at",
      text: "INVOICE DATE",
      sort: true,
      formatter: (cell, row) => {
        const date = row.invoice_date_at;
        const newDate = new Date(date);
        var day = newDate.getDate();
        day = day < 10 ? "0" + day : day;
        const month = newDate.toLocaleString("default", { month: "short" });
        const year = newDate.getFullYear();
        var hours = newDate.getHours();
        hours = hours < 10 ? "0" + hours : hours;
        var minutes = newDate.getMinutes();
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedDate = `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
        return <div>{formattedDate}</div>;
      },
    },
    {
      dataField: "total",
      text: "AMOUNT",
      sort: true,
    },
    {
      text: "STATUS",
      isDummy: true,
      formatter: (cell, row) => {
        const status = row.status;
        const amount = row.total;
        if (amount === 0) {
          return null; // Return null to render nothing
        } else if (status === "DRAFT" || status === "PENDING") {
          return (
            <>
              {invoicepoploader ? (
                <Button
                  className="Enable-Active-bttn invoice-list-btn"
                  disabled
                >
                  ...paying
                </Button>
              ) : (
                <>
                  {row.customer_id === bookingDetails.customer_id ? (
                    <Button
                      className="Enable-Active-bttn invoice-list-btn"
                      onClick={() => {
                        // Assuming `row.id` and `row.total` are accessible in this scope
                        getpaymentCards(row.id, row.total, row.status);
                      }}
                    >
                      PAY Now
                    </Button>
                  ) : (
                    "THIS INVOICE IS CREATED WITH DIFFERENT STAX ID."
                  )}
                </>
              )}
            </>
          );
        } else {
          return status;
        }
      },
    },
    {
      text: "ACTION",
      isDummy: true,
      formatter: (cell, row) => {
        const status = row.status;
        if (status === "PAID") {
          return "PAID";
          // return (
          //   <div className="button-group d-flex align-items-center gap-2">
          //     <SalesReceiptButton
          //       row={row}
          //       orderId={bookingDetails.order_id}
          //       customerId={bookingDetails.customer_id}
          //       clientId={bookingDetails.client_id}
          //     />
          //   </div>
          // );
        } else if (status === "ATTEMPTED") {
          return;
        } else {
          return (
            <div className="button-group">
              <Button className="Delete-Active-bttn me-2">
                <RiDeleteBin6Line />
              </Button>
            </div>
          );
        }
      },
    },
  ];

  const [lillypadloader, setLillypadLoader] = useState(false);

  const savetolillypad = async (id) => {
    const confirmed = await confirmModal.askConfirmation(
      "Are you sure you want to save this stax id to Lillypad?"
    );
    if (!confirmed) return;

    setLillypadLoader(true);
    const formData = new FormData();
    formData.append("customer_id", id);
    formData.append("user_id", bookingDetails.client_id);

    savestaxtolillypad(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status === 1) {
            const apiResponse = res.data;
            setEditbooking((prevDetails) => ({
              ...prevDetails,
              customer_id: id,
            }));
            setLillypadLoader(false);
          } else {
            console.log("Something went wrong");
            setLillypadLoader(false);
          }
        } else {
          console.log("Something went wrong");
          setLillypadLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLillypadLoader(false);
      });
  };

  const [edittimesheetshow, setEdittimesheet] = useState(false);

  const EdittimesheethandleClose = () => setEdittimesheet(false);
  const EdittimesheethandleShow = () => setEdittimesheet(true);

  const [technicianname, setTechnicianName] = useState("");
  const [timesheethours, setTimesheetHours] = useState("");
  const [timesheeteditid, setTimesheetEditId] = useState("");

  const [addtimesheetshow, setAddtimesheet] = useState(false);

  const AddtimesheethandleClose = () => setAddtimesheet(false);
  const AddtimesheethandleShow = () => setAddtimesheet(true);
  const [technicianTimesheetList, setTechnicianTimesheetList] = useState([]);

  const [selectedTechniciantimesheet, setSelectedTechnicianTimesheet] =
    useState("");
  const [selectedbilledhourstimesheet, setSelectedbilledhoursTimesheet] =
    useState("");
  const [selectednotestimesheet, setSelectednotesTimesheet] = useState("");

  const gettimesheetbookingdata = () => {
    const formData = new FormData();
    formData.append("booking_id", bookingDetails.order_id);

    gettimesheetbooking(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status === 1) {
          const apiResponse = res.data;
          // setTimesheetList(apiResponse.data);
          setTechnicianTimesheetList(apiResponse.data);
          AddtimesheethandleShow();
        } else {
          setTechnicianTimesheetList([]);
          console.log("Something went wrong");
        }
      } else {
        console.log("Something went wrong");
      }
    });
  };

  const handleEditTimesheetbilledhours = (event) => {
    const inputValue = event.target.value;
    const [hours, minutes] = inputValue.split(":");
    const validMinutes = Math.min(Math.max(parseInt(minutes || 0, 10), 0), 59);
    const formattedValue = `${hours || "00"}:${validMinutes
      .toString()
      .padStart(2, "0")}`;
    let totalDurationvar = convertToMinutes(formattedValue);
    setTimesheetHours(totalDurationvar);
  };

  const updateedittimesheet = () => {
    const formData = new FormData();
    formData.append("id", timesheeteditid);
    formData.append("billed_hours", timesheethours);

    updatetimesheet(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status === 1) {
          const apiResponse = res.data;
          // handleClose();
          NotificationManager.success("Timesheet updated successfully!");
          EdittimesheethandleClose();
          handleClose4();
        } else {
          console.log("Something went wrong");
        }
      } else {
        console.log("Something went wrong");
      }
    });
  };

  const [addstartTimes, setAddStartTimes] = useState("");
  const [addendTimes, setAddEndTimes] = useState("");

  const addedittimesheetfunc = () => {
    const formData = new FormData();
    formData.append("staff_id", selectedTechniciantimesheet);
    formData.append("order_id", bookingDetails.order_id);
    // formData.append("billed_hours", selectedbilledhourstimesheet);
    formData.append(
      "date_time",
      moment(addstartTimes).format("YYYY-MM-DD HH:mm")
    );
    formData.append("out_time", moment(addendTimes).format("YYYY-MM-DD HH:mm"));
    formData.append("notes", selectednotestimesheet);

    addedittimesheet(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status === 1) {
          const apiResponse = res.data;
          // setTimesheetList(apiResponse.data);
          AddtimesheethandleClose();
          handleClose4();
          setSelectedbilledhoursTimesheet("");
          setSelectednotesTimesheet("");
          setSelectedTechnicianTimesheet("");
        } else {
          console.log("Something went wrong");
        }
      } else {
        console.log("Something went wrong");
      }
    });
  };

  return (
    <div>
      <CommonConfirmModal
        show={confirmModal.show}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onClose={confirmModal.onClose}
      />
      {/* {
        loading ? (
          <div className="loading">
            <Roller />
          </div>
        ) : (<> */}

      {/* Add Card modal start here */}
      <Modal show={show6} className="Sidebar-Modal-end" onHide={handleClose6}>
        <Modal.Header closeButton>
          <Modal.Title>New Card Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Card Number</Form.Label>
                <Form.Control
                  type="tel"
                  className="custom-input"
                  value={cardNumber}
                  onChange={onCardNumberChange}
                  maxLength="19"
                />
                {cardNumbererror == true ? (
                  <p style={{ color: "red" }}>card number is required</p>
                ) : null}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Exp. Date</Form.Label>
                <Form.Control
                  required
                  type="Text"
                  placeholder="MM/YY"
                  className="custom-input"
                  value={cardExpDate}
                  {...getExpiryDateProps({
                    onChange: (e) => setCardExpDate(e.target.value),
                  })}
                />
                {cardExpDateerror == true ? (
                  <p style={{ color: "red" }}>please enter card exipry date</p>
                ) : (
                  ""
                )}
                {cardExpYearerror == true ? (
                  <p style={{ color: "red" }}>
                    Card expiration date should be in the future.
                  </p>
                ) : (
                  ""
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">CVV</Form.Label>
                <Form.Control
                  required
                  type="number"
                  placeholder="CVV"
                  className="custom-input"
                  value={cardCVV}
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 3);
                  }}
                  onChange={(e) => setCardCVV(e.target.value)}
                />
                {cardCVVerror == true ? (
                  <p style={{ color: "red" }}>please enter cvv</p>
                ) : (
                  ""
                )}
                {cardCVVerror && cardCVV.length != 3 ? (
                  <p style={{ color: "red" }}>cvv must have 3 digits</p>
                ) : (
                  ""
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Full Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Full Name"
                  className="custom-input"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                {fullNamerror == true ? (
                  <p style={{ color: "red" }}>please enter full name</p>
                ) : (
                  ""
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn justify-content-end">
              <button
                href="#"
                className="btn g-btn me-3"
                type="submit"
                onClick={handleAddCard}
              >
                Save
              </button>
              <button
                href="#"
                className="btn btn-danger"
                onClick={handleClose6}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Payment Method modal End here */}
      <Modal
        show={showModal7}
        className="Sidebar-Modal-end"
        onHide={handleClose7}
      >
        <Modal.Header closeButton>
          <Modal.Title>Fattmerchant Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          {paymentMethod &&
            paymentMethod.length != 0 &&
            paymentMethod.map((item, index) => {
              const cardOptionId = `cardOption${index}`;
              const isFirstCard = index === 0;
              const isChecked =
                selectedCard === cardOptionId || (isFirstCard && !selectedCard);
              return (
                <div class="form-check mb-3">
                  <div className="d-flex align-items-center">
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="cardOption"
                      id={`cardOption${index}`}
                      value={`cardOption${index}`}
                      checked={isChecked}
                      defaultChecked={index === 0}
                      onChange={(e) => {
                        setSelectedCard(e.target.value);
                        setPaymentMethodId(item.id);
                      }}
                    />
                    <label
                      class="form-check-label payment-card-details"
                      for="flexRadioDefault1"
                    >
                      <div className="card payment-card-details">
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div>
                              <div className="card-title h5">
                                ****-****-****-{item.card_last_four || " "}
                              </div>
                              <p className="card-text">
                                {item.nickname || " "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              );
            })}
          <div className="row">
            <div className="modal-btn justify-content-end">
              <button
                href="#"
                className="btn g-btn me-3"
                type="submit"
                onClick={payinvoice}
              >
                Save
              </button>
              <button
                href="#"
                className="btn btn-danger"
                onClick={handleClose7}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Payment Method modal End here */}

      {/* Edit Time sheet modal start here */}
      <Modal
        show={edittimesheetshow}
        onHide={EdittimesheethandleClose}
        className="Sidebar-Modal-end"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Timesheet Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Technician Name</Form.Label>
              <Form.Control
                disabled
                value={technicianname}
                onChange={(e) => setTechnicianName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
              <Form.Label>Billed Hours (HH:mm)</Form.Label>
              <InputMask
                mask="99:99"
                maskChar=""
                alwaysShowMask
                name="billed_hours"
                formatChars={{ 9: "[0-9]", ":": ":" }}
                placeholder="HH:mm"
                className="form-control"
                value={convertToHHMM(timesheethours)}
                onChange={handleEditTimesheetbilledhours}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="Cancel-bttn btn"
            onClick={EdittimesheethandleClose}
          >
            Close
          </Button>
          <Button className="Active-bttn btn" onClick={updateedittimesheet}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Edit Time sheet modal start here */}

      {/* Edit Time sheet modal start here */}
      <Modal
        show={addtimesheetshow}
        onHide={AddtimesheethandleClose}
        className="Sidebar-Modal-end"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Timesheet Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Technician Name</Form.Label>
              <Form.Select
                value={selectedTechniciantimesheet}
                onChange={(e) => setSelectedTechnicianTimesheet(e.target.value)}
              >
                <option value="">Select Technician</option>
                {technicianTimesheetList.map((tech) => (
                  <option key={tech.id} value={tech.id}>
                    {tech.fullname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Billed Hours (HH:mm)</Form.Label>
                    <InputMask
                      mask="99:99"
                      maskChar=""
                      alwaysShowMask
                      name="billed_hours"
                      disabled={selectedTechniciantimesheet === ""}
                      formatChars={{ '9': '[0-9]', ':': ':' }}
                      placeholder="HH:mm"
                      className="form-control"
                      value={convertToHHMM(selectedbilledhourstimesheet)}
                      onChange={handleaddTimesheetbilledhours}
                    />
                  </Form.Group> */}
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Start Time</Form.Label>
              <Form.Control
                type="datetime-local"
                value={addstartTimes}
                onChange={(e) => {
                  setAddStartTimes(e.target.value);
                }}
                placeholder=""
                disabled={selectedTechniciantimesheet === ""}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Stop Time</Form.Label>
              <Form.Control
                type="datetime-local"
                value={addendTimes}
                onChange={(e) => {
                  setAddEndTimes(e.target.value);
                }}
                placeholder=""
                disabled={selectedTechniciantimesheet === ""}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                disabled={selectedTechniciantimesheet === ""}
                value={selectednotestimesheet}
                onChange={(e) => setSelectednotesTimesheet(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="Cancel-bttn btn" onClick={AddtimesheethandleClose}>
            Close
          </Button>
          <Button
            className="Active-bttn btn"
            disabled={selectedTechniciantimesheet === ""}
            onClick={addedittimesheetfunc}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Edit Time sheet modal start here */}

      {/* edit appointment modal start */}
      <Modal
        show={show4}
        onHide={(e) => {
          handleClose4();
          setMultipleemailmsg(false);
          setEmailmsg(false);
        }}
        className="Sidebar-Modal-end"
      >
        <Modal.Header closeButton>
          <Modal.Title>Card Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-8 d-flex">
              <Form.Group controlId="formBasicEmail">
                <Form.Label className="fw-bold">Lillypad Stax Id:</Form.Label>
                <div></div>
              </Form.Group>
              <div className="create-stax-id mb-3">
                {bookingDetails.customer_id == "" ? (
                  <button
                    className="btn btn-primary actions-btn"
                    onClick={createStaxId}
                  >
                    Create Stax Id
                  </button>
                ) : (
                  <>
                    <p className="mb-0">{bookingDetails.customer_id}</p>
                    {multipleemailmsg && (
                      <p>
                        <a
                          href={`https://app.staxpayments.com/#/customers?keywords[]=${encodeURIComponent(
                            bookingDetails.client_email
                              .replace(/[:\s]/g, "")
                              .trim()
                          )}&page=1`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "red", fontWeight: "500" }}
                        >
                          Multiple accounts associated with this email.{" "}
                          <LuExternalLink />
                        </a>
                      </p>
                    )}
                    {emailmsg && (
                      <p style={{ color: "red", fontWeight: "500" }}>
                        Current stax id of lillypad not matching with stax id.
                      </p>
                    )}
                    {staxaccount && (
                      <p>
                        <a
                          href={`https://app.staxpayments.com/#/customers?keywords[]=${encodeURIComponent(
                            bookingDetails.client_email
                              .replace(/[:\s]/g, "")
                              .trim()
                          )}&page=1`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "red", fontWeight: "500" }}
                        >
                          This client may already have a stax id.{" "}
                          <LuExternalLink />
                        </a>
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="payment-settings-content-header create-stax-id-btn mb-3">
                <button
                  href="#"
                  class="btn Add-bttn ms-auto"
                  onClick={handleShow6}
                >
                  <span>
                    <BsPlusLg />
                  </span>
                  Add Card
                </button>
              </div>
            </div>
          </div>

          <div>
            <div className="fs-6 fw-bold">Stax data</div>
          </div>
          {!lillypadloader ? (
            staxData &&
            staxData.map((item, index) => (
              <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
                <div>
                  <p className="mb-0">{item.id}</p>
                </div>
                {bookingDetails.customer_id !== item.id ? (
                  <button
                    className="outline-none border-none btn "
                    style={{
                      backgroundColor: "#74b216",
                      padding: "1px 3px",
                      fontSize: "12px",
                      color: "#ffffff",
                    }}
                    onClick={() => savetolillypad(item.id)}
                  >
                    Use This
                  </button>
                ) : (
                  <button
                    className="outline-none border-none btn "
                    style={{
                      backgroundColor: "#74b216",
                      padding: "1px 3px",
                      fontSize: "12px",
                      color: "#ffffff",
                    }}
                    disabled
                  >
                    Current
                  </button>
                )}
              </div>
            ))
          ) : (
            <div>Loading...</div>
          )}

          <div
            className=""
            style={{
              display: bookingDetails.customer_id === "" ? "none" : "block",
            }}
          >
            <div className="booking-details-deta-inner">
              <ul className="ct-cal-booking-details">
                <li className="ct-cal-booking-details-item">
                  <label>Name</label>
                  <span>: {bookingDetails.client_name}</span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Email</label>
                  <span>{bookingDetails.client_email} </span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Phone</label>
                  <span>{bookingDetails.client_phone}</span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Address</label>
                  <span>: {bookingDetails.client_address}</span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Price</label>
                  <span>: {`$` + invoiceprice}</span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Booking Discount Price</label>
                  <span>
                    :{" "}
                    {"$" +
                      getCalculateddiscount(
                        bookingDetails.booking_price_test,
                        bookingDetails.booking_discount
                      )}
                  </span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Booking Discount</label>
                  <span>:{"$" + bookingDetails.booking_discount}</span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Billing Notes</label>
                  <span>
                    :{" "}
                    {bookingDetails && bookingDetails.booking_notes
                      ? bookingDetails.booking_notes
                      : " "}
                  </span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Notes</label>
                  <span>
                    {invoicenotes === " " ? " " : getNotes(invoicenotes)}{" "}
                  </span>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Team Cleaning Time</label>
                  <span>: {cleaningtime}</span>
                </li>
                {/* <li className="ct-cal-booking-details-item">
                  <label>Technician Time</label>
                  <span>: {gettechnicialtime(bookingtimesheetcleaningtime)}</span>
                </li> */}

                <li className="ct-cal-booking-details-item gregr">
                  <label>Technician Time</label>
                  <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center button-container">
                      {bookingtimesheetcleaningtime &&
                        bookingtimesheetcleaningtime.map((item, index) => (
                          <span key={index} className="technician-string">
                            : {item.fullname} (
                            {convertToHHMM(item.time_difference)})
                            <GrFormEdit
                              className="edit-icon hidden"
                              size={20}
                              onClick={() => {
                                EdittimesheethandleShow(true);
                                setTechnicianName(item.fullname);
                                setTimesheetHours(item.time_difference);
                                setTimesheetEditId(item.id);
                              }}
                            />
                          </span>
                        ))}
                    </div>
                    <IoIosAddCircleOutline
                      size={25}
                      className="position-absolute"
                      style={{ right: "0" }}
                      strokeWidth={2}
                      onClick={() => {
                        AddtimesheethandleShow();
                        gettimesheetbookingdata();
                      }}
                    />
                  </div>
                </li>
                <li className="ct-cal-booking-details-item">
                  <label>Timesheet Notes</label>
                  <span>
                    : {gettechtimesheetnotes(bookingDetails.booking_time_note)}
                  </span>
                </li>
              </ul>
            </div>

            <div className="payment-invoice mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="card-title-invoice">
                    <h3>Invoice</h3>
                    <div className="add-invoice-btn">
                      <button className="btn-invoice" onClick={addRow}>
                        <MdAdd />
                        Add More
                      </button>
                    </div>
                  </div>
                  <div className="invoice-list">
                    <table className="table table-invoice">
                      <thead>
                        <tr>
                          <th>DETAILS</th>
                          <th>QUANTITY</th>
                          <th>PRICE</th>
                          <th>AMOUNT</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index} className="mt-3">
                            <td style={{ width: "100%" }}>
                              <div className="my-1 flex-nowrap input-group">
                                <Form.Select
                                  // value={row.service}
                                  aria-label="Default select example"
                                  onChange={(e) =>
                                    updateRow(index, "service", e.target.value)
                                  }
                                >
                                  <option>Service Name</option>
                                  {productlist.map((item, itemIndex) => (
                                    <option
                                      key={itemIndex}
                                      value={`${item.id} ${item.item}`}
                                      selected={
                                          row?.service === "Discounts" ||
                                          String(row?.id ?? "").trim() ===
                                            "ace0d202-c9dc-4bef-821d-62ef309ffe2b"
                                            ? String(row?.id ?? "") ===
                                              String(item?.id ?? "")
                                            : item?.is_service
                                            ? String(item.id) ===
                                              String(defaultServiceValue)
                                            : String(row.id) === String(item.id)
                                      }
                                    >
                                      {item.item}
                                    </option>
                                  ))}
                                </Form.Select>
                              </div>
                              <div className="my-1 flex-nowrap input-group">
                                <input
                                  name="notes"
                                  type="text"
                                  className="form-control"
                                  value={row.notes}
                                  onChange={(e) =>
                                    updateRow(index, "notes", e.target.value)
                                  }
                                />
                              </div>
                            </td>
                            <td style={{ width: "100%" }}>
                              <div className="my-1 flex-nowrap input-group">
                                <input
                                  name="quantity"
                                  type="text"
                                  className="form-control"
                                  value={row.quantity}
                                  onChange={(e) => {
                                    updateRow(
                                      index,
                                      "quantity",
                                      e.target.value
                                    );
                                    const pricequantity = e.target.value;
                                    const total =
                                      parseFloat(pricequantity) * row.price;
                                    updateRow(index, "total", total);
                                  }}
                                  disabled={row.service === "Discount"}
                                />
                              </div>
                            </td>
                            <td style={{ width: "100%" }}>
                              <div className="my-1 flex-nowrap input-group price-width">
                                <input
                                  name="Price"
                                  type="text"
                                  className="form-control"
                                  value={row.price}
                                  onChange={(e) => {
                                    const priceValue = e.target.value;
                                    updateRow(index, "price", priceValue);
                                    const total =
                                      parseFloat(priceValue) * row.quantity;
                                    updateRow(index, "total", total);
                                  }}
                                />
                              </div>
                            </td>
                            <td style={{ width: "100%" }}>
                              <b>
                                {row.total ? `$${row.total.toFixed(2)}` : "$0"}
                              </b>
                            </td>
                            {index === 0 ? (
                              <></>
                            ) : (
                              <button
                                className="remove-row-btn"
                                onClick={() => removeRow(index)}
                              >
                                <MdClose />
                              </button>
                            )}
                          </tr>
                        ))}
                        <tr></tr>
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center gap-4 mb-3">
                      <div className="total">
                        <b>Total :</b>
                      </div>
                      <div className="w-50">
                        <div style={{ width: "100%" }}>
                          <div className="my-1 flex-nowrap input-group">
                            <input
                              name="discount"
                              type="text"
                              className="form-control"
                              value={`$${calculateTotal(
                                rows,
                                discountinvoice
                              )}`}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="payment-settings-content-header d-flex justify-content-beetwin align-items-center mb-4">
              {invoiceLoaderNew ? (
                <button href="#" class="btn Add-bttn ms-auto">
                  <Spinner animation="border" variant="success" />
                </button>
              ) : (
                <button
                  href="#"
                  class="btn Add-bttn ms-auto"
                  onClick={createinvoice}
                  disabled={
                    isNaN(calculateTotal(rows, discountinvoice)) ||
                    calculateTotal(rows, discountinvoice) < 0
                  }
                >
                  <span>
                    <BsPlusLg />
                  </span>
                  Create Invoice
                </button>
              )}
            </div>
            <hr />
            <button class="btn Add-bttn ms-auto" onClick={sendinvoicetouser}>
              SEND INVOICE TO USER 2
            </button>
            <div class="payment-settings-content-header d-flex justify-content-beetwin align-items-center mb-4">
              {/* <button class="btn Add-bttn ms-auto" onClick={getinvoice}>
                Refresh Invoice List
              </button> */}

              {invoiceLoader ? (
                <button class="btn Add-bttn ms-auto">
                  <Spinner animation="border" variant="success" />
                </button>
              ) : (
                <button class="btn Add-bttn ms-auto" onClick={getinvoice}>
                  Refresh Invoice List
                </button>
              )}
            </div>
            <div className="row">
              <h3>Invoice List</h3>
              <div className="col-md-12 mt-4">
                <div className="animated fadeIn">
                  {invoiceLoader ? (
                    <Spinner animation="grow" variant="success" />
                  ) : (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header d-flex table-card-header">
                            <Form.Group>
                              <div className="d-flex">
                                <div addonType="prepend"></div>
                                <Form.Control
                                  type="text"
                                  placeholder="Keywords..."
                                  onChange={handleChange}
                                />
                              </div>
                            </Form.Group>
                          </div>
                          <div className="card-body calendar-thing">
                            <BootstrapTable
                              bootstrap4
                              keyField="id"
                              data={invoiceList}
                              columns={columns}
                              pagination={pagination}
                            />
                            <style>
                              {`
                                  td {
                                    
                                  }
                                `}
                              s
                            </style>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose4}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* edit appointment modal end */}

      {/* edit appointment modal start */}
      <Modal
        show={showBookingDetails}
        onHide={() => {
          handleClose2();
          onCloseidChangebooking(0);
          onCloseidChangeoldbookingid(order_id);
        }}
        className="Sidebar-Modal-end"
      >
        <Modal.Header closeButton>
          <Modal.Title>Booking Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="btn-header-list">
              <button
                style={{ display: "none" }}
                className="btn g-btn"
                onClick={(e) => {
                  getsubserviceaddons();
                  getinvoice();
                  setInvoiceprice(bookingDetails.price);
                }}
              >
                Fattmerchant Payment
              </button>
              {bookingDetails.booking_status != "CO" && (
                <button className="btn b-btn" onClick={getEditbooking}>
                  Edit Booking Detail
                </button>
              )}
            </div>
            <div className="booking-details-deta">
              <div className="booking-details-deta-inner">
                <div className="booking-status">
                  <div className="w-40">Booking Status:</div>
                  <div className="booking-status-view">
                    <p>
                      {getStatusofbookings(bookingDetails.booking_status)}
                      {getStatus(bookingDetails.book_by)}
                    </p>
                    <div className="time-list d-flex">
                      <div className="date-list-inner">
                        <TbCalendar />{" "}
                        {getDateFormate(bookingDetails.appointment_starttime)}
                      </div>
                      <div className="time-list-inner">
                        <TbClock /> {bookingDetails.appointment_start_time}
                      </div>
                    </div>
                    <div className="time-list d-flex">
                      <div className="date-list-inner">
                        <TbCalendar />{" "}
                        {getDateFormate(bookingDetails.appointment_starttime)}
                      </div>
                      <div className="time-list-inner">
                        {/* <TbClock /> {bookingEndTime(bookingDetails.appointment_start_time, bookingDetails.booking_duration)} */}
                        <TbClock />{" "}
                        {getdividetime(
                          bookingDetails.appointment_start_time,
                          bookingDetails.booking_duration,
                          bookingDetails.staff_ids
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="ct-cal-booking-details">
                  <li className="ct-cal-booking-details-item">
                    <label>Service</label>
                    <span>{bookingDetails.service_title}</span>
                  </li>
                  {/* <li className="ct-cal-booking-details-item">
                  <label>Methods</label>
                  <span>: Home Size</span>
                </li> */}
                  <li className="ct-cal-booking-details-item">
                    <label>Units</label>
                    <span>{bookingDetails.unit_title} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Addons</label>
                    <span>
                      :{" "}
                      {bookingDetails.addons_title
                        ? bookingDetails.addons_title
                        : "No Addons"}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Appointment notes</label>
                    <span>
                      {bookingDetails.notes === " "
                        ? " "
                        : getNotes(bookingDetails.notes)}{" "}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Booking Address</label>
                    <span>: {bookingDetails.client_address}</span>
                  </li>
                  <li className="ct-cal-booking-details-item-req">
                    <label>Special Client Request for This Booking</label>
                     :&nbsp;
                     <span
                        dangerouslySetInnerHTML={{
                          __html: bookingDetails.request?.replace(/\r?\n/g, "<br />"),
                        }}
                      />
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Preferences</label>
                    <span>: {bookingDetails.client_preferences}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Booking Notes</label>
                    <span>
                      :{" "}
                      {bookingDetails && bookingDetails.booking_notes
                        ? bookingDetails.booking_notes
                        : " "}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Billed Amount</label>
                    <span>{bookingDetails.billed_amt}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Billed Hours</label>
                    <span>: {bookingDetails.booking_duration} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Booking Price</label>
                    <span>: {bookingDetails.booking_price}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Booking Discount Price</label>
                    <span>
                      :{" "}
                      {"$" +
                        getCalculateddiscount(
                          bookingDetails.booking_price_test,
                          bookingDetails.booking_discount
                        )}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Booking Discount</label>
                    <span>:{"$" + bookingDetails.booking_discount}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Estimated Billed Amount</label>
                    <span>: {bookingDetails.estimated_price} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Estimated Billed Hours</label>
                    <span>: {bookingDetails.estimated_duration} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Scheduled Duration</label>
                    <span>
                      :{" "}
                      {getscheduledtime(
                        bookingDetails.booking_duration,
                        bookingDetails.staff_ids,
                        bookingDetails.order_date
                      )}{" "}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Team Cleaning Time</label>
                    <span>: {bookingDetails.cleaning_time} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Technician Time</label>
                    <span>
                      :{" "}
                      {gettechnicialtime(
                        bookingDetails.booking_timesheet_cleaning_time
                      )}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Timesheet Notes</label>
                    <span>
                      :{" "}
                      {gettechtimesheetnotes(bookingDetails.booking_time_note)}
                    </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label></label>
                    <Link
                      to={`/timesheet?oid=${bookingDetails.order_id}`}
                      className="ct-cal-booking-details-notes"
                      target="_blank"
                    >
                      <button className="btn b-btn">
                        Edit Timesheet Detail
                      </button>
                    </Link>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <h6 class="ct-customer-details-hr">Customer</h6>
                      <button
                        className="btn b-btn"
                        onClick={() => {
                          // getUserdata();
                          callChildFunction(bookingDetails.client_id);
                        }}
                      >
                        Edit Customer Detail
                      </button>
                    </div>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Name</label>
                    <span>{bookingDetails.client_name}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Email</label>
                    <span>{bookingDetails.client_email} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Phone</label>
                    <span>{bookingDetails.client_phone}</span>
                  </li>
                 
                  <li
                    className="ct-cal-booking-details-item"
                    style={{ display: "none" }}
                  >
                    <button
                      className="btn view-more-content less-btn"
                      onClick={removeClass}
                    >
                      See Less
                    </button>
                  </li>
                  <li
                    className="ct-cal-booking-details-item"
                    style={{ display: "none" }}
                  >
                    <button
                      className="btn view-more-content more-btn"
                      onClick={addClass}
                    >
                      See More
                    </button>
                  </li>
                  {/* <div className="view-more-content-hide"> */}
                  <li
                    className="ct-cal-booking-details-item"
                    style={{ display: "none" }}
                  >
                    <label>Payment</label>
                    <span>: Pay Locally</span>
                  </li>
                  <li
                    className="ct-cal-booking-details-item"
                    style={{ display: "none" }}
                  >
                    <label>Notes</label>
                    <span>: {bookingDetails.client_notes} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Family Info</label>
                    <span>: {bookingDetails.client_family_info} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Parking Access</label>
                    <span>: {bookingDetails.client_parking_access} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Notes</label>
                    <span>: {bookingDetails.notes_new} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Client notes from tech</label>
                    <span>: {bookingDetails.client_technician_notes} </span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Special Instructions from Client</label>
                    <span>: {bookingDetails.client_special_instructions}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Special Instructions from Admin</label>
                      <span>: {bookingDetails.admin_special_instructions}</span>
                  </li>
                  
                  {/* </div> */}
                  <hr />
                  <li className="ct-cal-booking-details-item">
                    <label>Assiged Staff</label>
                    <span>{getassigendstaff(bookingDetails.staff)}</span>
                  </li>
                  <li className="ct-cal-booking-details-item">
                    <label>Preferred Technician</label>
                    <span>
                      :{" "}
                      {bookingDetails.client_preferrend_technician == null &&
                        bookingDetails.client_preferrend_technician == "null"
                        ? ""
                        : bookingDetails.client_preferrend_technician}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="button-group1">

            {bookingDetails.booking_status != "DUC" && (
              <Button
                className="dis-uncf-confirm-Active-bttn"
                onClick={disuncnfcomplatebooking}
                style={{ backgroundColor: "#90EE90", color: "#403c3c", fontWeight: "700" }}
              >
                Dis. UNCNF.
              </Button>
            )}

            {bookingDetails.customer_id !== 0 &&
              bookingDetails.customer_id !== null &&
              bookingDetails.customer_id !== "" ? (
              <Button
                className="pay-Active-bttn"
                onClick={(e) => {
                  getsubserviceaddons();
                  getstaxaccountfunc();
                  getinvoice();
                  setInvoiceprice(bookingDetails.price);
                  setInvoicenotes(bookingDetails.notes);
                  setCleaningTime(bookingDetails.cleaning_time);
                  setBookingtimesheetcleaningtime(
                    bookingDetails.booking_timesheet_cleaning_time
                  );
                  setBookingtimenote(bookingDetails.booking_time_note);
                }}
              >
                <FaMoneyBillAlt /> Bill client
              </Button>
            ) : (
              <Button className="pay-Active-bttn" onClick={createStaxId}>
                <FaMoneyBillAlt /> Create Stax Id
              </Button>
            )}
            {bookingDetails.booking_status == "CO" &&
              bookingDetails.booking_status != "" && (
                <>
                  <Button
                    className="Delete-Active-bttn"
                    onClick={uncomplatebooking}
                  >
                    <FaTimesCircle /> Uncomplete
                  </Button>
                </>
              )}
            {(bookingDetails.booking_status == "C" || bookingDetails.booking_status == "FSR" || bookingDetails.booking_status == "UC") &&
              bookingDetails.booking_status != "" ? (
              <>
                <Button
                  className="confirm-Active-bttn"
                  onClick={complatebooking}
                >
                  <FaCheckCircle /> Complete
                </Button>
                {/* {bookingDetails.customer_id !== 0 && bookingDetails.customer_id !== null && bookingDetails.customer_id !== "" ? (
                    <Button className="pay-Active-bttn" onClick={(e) => {
                      getsubserviceaddons();
                      getinvoice();
                      setInvoiceprice(bookingDetails.price);
                      setInvoicenotes(bookingDetails.notes)
                      setCleaningTime(bookingDetails.cleaning_time);
                      setBookingtimesheetcleaningtime(bookingDetails.booking_timesheet_cleaning_time);
                      setBookingtimenote(bookingDetails.booking_time_note);
                    }}>
                      <FaMoneyBillAlt /> Bill client
                    </Button>
                  ) : (
                    <Button className="pay-Active-bttn" onClick={createStaxId}>
                      <FaMoneyBillAlt /> Create Stax Id
                    </Button>
                  )} */}

                <Button
                  className="unconfirm-Active-bttn"
                  onClick={unconfirmbooking}
                >
                  <FaRegTimesCircle /> Unconfirm
                </Button>
                <div className="delete-btn">
                    <Button
                      className="Delete-Active-bttn"
                      onClick={(e) => {
                        setAddClasss(true);
                        setAddRecurringClasss(false);
                      }}
                    >
                      <RiDeleteBin6Line /> Cancel
                    </Button>
                    <div
                      className={
                        "confirm-cancel-modal" + (addClasss ? " show" : "")
                      }
                    >
                      <h3 class="popover-title">Cancel this appointment?</h3>
                      <div className="popover-content">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Reason for Cancellation <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={cancelReason}
                            onChange={(e) => {
                              setCancelReason(e.target.value);
                              if (cancelReasonError) {
                                setCancelReasonError("");
                              }
                            }}
                            placeholder="Please provide a reason for cancellation"
                            required
                            isInvalid={!!cancelReasonError}
                          />
                          {cancelReasonError && (
                            <Form.Control.Feedback type="invalid">
                              {cancelReasonError}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                        <div className="btn-list">
                          <div className="btn-delete">
                            <Button
                              className="confirm-delete"
                              onClick={cancelbookingbyidadmins}
                              disabled={cancelLoader}
                            >
                              {cancelLoader ? (
                                <Spinner animation="border" className="border-black" />
                              ) : (
                                "Yes"
                              )}
                            </Button>
                          </div>
                          <div className="btn-cancel">
                            <Button
                              className="cancel-delete"
                              onClick={(e) => {
                                setAddClasss(false);
                                setCancelReason("");
                                setCancelReasonError("");
                              }}
                            >
                              No
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </>
            ) : (
              ""
            )}
            { ((bookingDetails.booking_status == "A" || bookingDetails.booking_status == "AC" || bookingDetails.booking_status == "DUC") &&
              bookingDetails.booking_status != "" ) &&  (
                <>
                  <Button
                    className="confirm-Active-bttn"
                    onClick={confirmbooking}
                  >
                    <FaCheck /> Confirm
                  </Button>
                  {/* <Button
                    className="reschedule-Active-bttn"
                    onClick={rescheduleData}
                    style={{ display: "none" }}
                  >
                    <FaRegEdit /> Reschedule
                  </Button>

                  <Button
                    className="reject-Active-bttn"
                    onClick={rejectbooking}
                    style={{ display: "none" }}
                  >
                    <FaThumbsDown /> Reject
                  </Button> */}

                  <div className="delete-btn">
                    <Button
                      className="Delete-Active-bttn"
                      onClick={(e) => {
                        setAddClasss(true);
                        setAddRecurringClasss(false);
                      }}
                    >
                      <RiDeleteBin6Line /> Cancel
                    </Button>
                    <div
                      className={
                        "confirm-cancel-modal" + (addClasss ? " show" : "")
                      }
                    >
                      <h3 class="popover-title">Cancel this appointment?</h3>
                      <div className="popover-content">
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Reason for Cancellation <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={cancelReason}
                            onChange={(e) => {
                              setCancelReason(e.target.value);
                              if (cancelReasonError) {
                                setCancelReasonError("");
                              }
                            }}
                            placeholder="Please provide a reason for cancellation"
                            required
                            isInvalid={!!cancelReasonError}
                          />
                          {cancelReasonError && (
                            <Form.Control.Feedback type="invalid">
                              {cancelReasonError}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                        <div className="btn-list">
                          <div className="btn-delete">
                            <Button
                              className="confirm-delete"
                              onClick={cancelbookingbyidadmins}
                              disabled={cancelLoader}
                            >
                              {cancelLoader ? (
                                <Spinner animation="border" className="border-black" />
                              ) : (
                                "Yes"
                              )}
                            </Button>
                          </div>
                          <div className="btn-cancel">
                            <Button
                              className="cancel-delete"
                              onClick={(e) => {
                                setAddClasss(false);
                                setCancelReason("");
                                setCancelReasonError("");
                              }}
                            >
                              No
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            {bookingDetails.booking_status == "R" &&
              bookingDetails.booking_status != "" && (
                <>
                  <Button
                    className="confirm-Active-bttn"
                    onClick={activebooking}
                  >
                    <FaToggleOn /> Active
                  </Button>
                </>
              )}
            {bookingDetails.recurring_id != 0 &&
              bookingDetails.recurring_id != null &&
              bookingDetails.recurring_id != "" ? (
              <div className="delete-btn">
              <Button
                className="Delete-Active-bttn"
                onClick={(e) => {
                  setAddRecurringClasss(true);
                  setAddClasss(false);
                }}
              >
                {" "}
                <RiDeleteBin6Line /> Cancel Recurring{" "}
              </Button>
              <div
              className={
                "confirm-cancel-modal" + (addRecurringClasss ? " show" : "")
              }
            >
              <h3 class="popover-title">Cancel this appointment?</h3>
              <div className="popover-content">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Reason for Cancellation Recurring <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={cancelRecurringReason}
                    onChange={(e) => {
                      setCancelRecurringReason(e.target.value);
                      if (cancelRecurringReasonError) {
                        setCancelRecurringReasonError("");
                      }
                    }}
                    placeholder="Please provide a reason for cancellation recurring"
                    required
                    isInvalid={!!cancelRecurringReasonError}
                  />
                  {cancelRecurringReasonError && (
                    <Form.Control.Feedback type="invalid">
                      {cancelRecurringReasonError}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                <div className="btn-list">
                  <div className="btn-delete">
                    <Button
                      className="confirm-delete"
                      onClick={cancelreccuringbooking}
                      disabled={cancelLoader}
                    >
                      {cancelLoader ? (
                        <Spinner animation="border" className="border-black" />
                      ) : (
                        "Yes"
                      )}
                    </Button>
                  </div>
                  <div className="btn-cancel">
                    <Button
                      className="cancel-delete"
                      onClick={(e) => {
                        setAddRecurringClasss(false);
                        setCancelRecurringReason("");
                        setCancelRecurringReasonError("");
                      }}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
              </div>
            ) : (
              // <Button className="Delete-Active-bttn" onClick={deletereccuringbooking} disabled> <RiDeleteBin6Line /> Delete all recurring </Button>
              ""
            )}
            
          </div>
        </Modal.Footer>
      </Modal>
      {/* edit appointment modal end */}

      <Modal show={show3} onHide={handleClose3} className="Sidebar-Modal-end">
        <Modal.Header closeButton>
          <Modal.Title>Edit Booking Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="edit-booking-form">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Service : {editbooking.service_name}</Form.Label>
                </Form.Group>
              </div>
              <div className="col-md-6" style={{ display: "none" }}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Method : Home Size</Form.Label>
                </Form.Group>
              </div>
            </div>
            <div className="row" style={{ display: "none" }}>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Billed Amount : </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text">$</span>
                    <input
                      type="number"
                      placeholder="0"
                      className="form-control"
                      disabled
                      value={editbooking.billed_amount || totalAmount || 0}
                      name="billed_amount"
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Price : </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text">$</span>
                    <input
                      type="text"
                      className="form-control"
                      value={editbooking.billed_amount}
                      name="billed_amount"
                      onChange={handleEditInputChange3}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>
            <div className="row" style={{ display: "none" }}>
              <div className="col-md-12">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Duration : </Form.Label>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <BsStopwatch />
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="10"
                    disabled
                    value={editbooking.hours}
                  />
                  <span className="input-group-text">Hours</span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-group mb-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="30"
                    disabled
                    value={editbooking.mints}
                  />
                  <span className="input-group-text">Minutes</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="Service-details-box-inner-title">
                  <h5>Sub Services</h5>
                </div>
              </div>
              {EditSubServices.map((subservice, index) => {
                return (
                  <div className="col-md-12">
                    <div className="Service-details-box-inner extra-service mb-3">
                      <div className="left-side">
                        <div className="d-flex align-items-center">
                          <h3 className="Service-details-box-inner-title">
                            {subservice.units_title}
                          </h3>
                        </div>
                      </div>
                      <div className="right-side">
                        <div className="d-flex align-items-center">
                          <div className="extra-service-icon">
                            <Button
                              href="#"
                              className="add-item-btn"
                              disabled={subservice.quantity == 1 ? true : false}
                              onClick={(e) => {
                                setEditstart(true);
                                changeCounter3("decrement", subservice.id);
                              }}
                            >
                              -
                            </Button>
                          </div>
                          <div className="extra-service-value">
                            {subservice.quantity}
                          </div>
                          <div className="extra-service-icon">
                            <Button
                              href="#"
                              className="add-item-btn"
                              disabled={subservice.quantity == 6 ? true : false}
                              onClick={(e) => {
                                setEditstart(true);
                                changeCounter3("increment", subservice.id);
                              }}
                            >
                              +
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="Service-details-box-inner-title">
                  <h5>Addons</h5>
                </div>
              </div>
              {editaddons.map((value, index) => {
                return (
                  <div className="col-md-12">
                    <div className="Service-details-box-inner extra-service mb-3">
                      <div className="left-side">
                        <div className="d-flex align-items-center">
                          <h3 className="Service-details-box-inner-title">
                            {value.addon_service_name}
                          </h3>
                        </div>
                      </div>
                      <div className="right-side">
                        <div className="d-flex align-items-center">
                          <div className="extra-service-icon">
                            <Button
                              href="#"
                              className="add-item-btn"
                              disabled={
                                value.addons_service_qty == 0 ? true : false
                              }
                              onClick={(e) => {
                                setEditstart(true);
                                changeeditaddons("decrement", value.id);
                              }}
                            >
                              -
                            </Button>
                          </div>
                          <div className="extra-service-value">
                            {value.addons_service_qty}
                          </div>
                          <div className="extra-service-icon">
                            <Button
                              href="#"
                              className="add-item-btn"
                              disabled={
                                value.addons_service_qty == 6 ? true : false
                              }
                              onClick={(e) => {
                                setEditstart(true);
                                changeeditaddons("increment", value.id);
                              }}
                            >
                              +
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="row">
              <div className="estimated-bottom">
                <div className="estimated-head">
                  <h5>Estimated Price && Duration</h5>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Change Billed Amount</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={Math.round(editbookingestimatedPrice)}
                          onChange={(e) => {
                            handlechageeditamount(e.target.value);
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Change Discount</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={Math.round(editbookingdiscount)}
                          onChange={(e) => {
                            handlechageeditdiscountamount(e.target.value);
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Discount Amount</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="text"
                          placeholder=""
                          disabled
                          value={Math.round(editbookingchangesamount)}
                          onChange={(e) => {
                            handlechageeditamount(e.target.value);
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Change Billed Hours</Form.Label>
                      <InputMask
                        mask="99:99"
                        maskChar=""
                        alwaysShowMask
                        formatChars={{ 9: "[0-9]", ":": ":" }}
                        placeholder="HH:mm"
                        className="form-control"
                        value={convertToHHMM(editbookingestimatedDuration)}
                        onChange={(e) => {
                          handlechageedittime(e);
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Estimated Billed Amount</Form.Label>

                      {editbooking.booking_discount > 0 ? (
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={
                            "$" +
                            Math.round(edittotalAmount) +
                            " to $" +
                            Math.round(editbookingchangesamount) || ""
                          }
                          disabled
                        />
                      ) : (
                        <Form.Control
                          type="text"
                          placeholder=""
                          value={
                            "$" +
                            Math.round(edittotalAmount) +
                            " to $" +
                            Math.round(editbookingestimatedPrice) || ""
                          }
                          disabled
                        />
                      )}

                      {/* // <Form.Control
                          //   type="text"
                          //   placeholder=""
                          //   value={("$" + edittotalAmount + " to " + "$" + Math.round(editbookingestimatedPrice)) || ""}
                          //   disabled
                          // /> */}
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Estimated Billed Hours</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        disabled
                        value={
                          convertToHHMM(editbaseTime) +
                          " to " +
                          convertToHHMM(editbookingestimatedDuration) || ""
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Client Name: </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Client Name"
                    value={editbooking.client_name}
                    name="client_name"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Client Email: </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Client Email"
                    value={editbooking.client_email}
                    name="client_email"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Client Address: </Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    aria-label="With textarea"
                    value={editbooking.client_address}
                    name="client_address"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Appointment City: </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Appointment City"
                    value={editbooking.appointment_city}
                    name="appointment_city"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Appointment State: </Form.Label>
                  {/* <Form.Control
                  type="text"
                  placeholder="Enter Appointment State"
                  value={editbooking.appointment_state}
                  name="appointment_state"
                  onChange={handleEditInputChange3}
                /> */}

                  <Form.Select
                    aria-label="Default select example"
                    className="custom-select-box"
                    onChange={(e) => {
                      setEditbookingstate(e.target.value);
                    }}
                    name="state"
                  >
                    {states.map((state) => (
                      <option
                        value={state.stateCode}
                        selected={
                          editbooking.appointment_state == state.stateCode
                        }
                      >
                        {state.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Appointment Zip: </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Appointment Zip"
                    value={editbooking.appointment_zip}
                    name="appointment_zip"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Assign Appointment to Staff</Form.Label>
                  {selectedOptions && (
                    <Select
                      isMulti
                      defaultValue={selectedOptions}
                      options={staffList}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(e) => {
                        setAssignStaff(e);
                      }}
                    />
                  )}
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Appointment Notes: </Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    aria-label="With textarea"
                    value={editbooking.appointment_note}
                    name="appointment_note"
                    onChange={handleEditInputChange3}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Start Date: </Form.Label>
                  <Form.Control
                    type="date"
                    value={EditbookingStartDate || ""}
                    onChange={(e) => {
                      setEditbookingStartDate(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Start Time: </Form.Label>
                  <Form.Control
                    type="time"
                    value={EditbookingStartTime || ""}
                    onChange={
                      // (e) => {
                      //   setEditbookingStartTime(e.target.value)
                      // }
                      handleStartTimeChange
                    }
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>End Date: </Form.Label>
                  <Form.Control
                    type="date"
                    value={EditbookingStartDate || ""}
                    onChange={(e) => {
                      setEditbookingStartDate(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>End Time: </Form.Label>
                  <Form.Control
                    type="time"
                    value={
                      // moment(editbooking.start_time, "HH:mm:ss").add(expedtedendtime, "minutes").format("HH:mm:ss")
                      // getCalculatedEndTime(editbooking.start_time, expedtedendtime)
                      editbookingtimeEnd
                    }
                  />
                </Form.Group>
              </div>
            </div>
            {editbooking.book_by == 1 && 
                        <div className="row">
                          <div className="col-md-12">
                            <div className="estimated-head">
                              <h5>Special Client Requests</h5>
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            {/* <Form.Group className="mb-3">
                              <Form.Label>Booking Time:</Form.Label>
                              <Form.Select
                                value={editBookingTime || ""}
                                onChange={(e) => setEditBookingTime(e.target.value)}
                                className="p-2"
                                style={{ border: "1px solid #ccc" }}
                              >
                                <option value="">Select time</option>
                                {EDIT_BOOKING_TIME_SLOTS.map((slot) => (
                                  <option key={slot.value} value={slot.value}>
                                    {slot.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group> */}
                            <Form.Group className="mb-3">
                              <Form.Label>Do you have pets?</Form.Label>
                              <div>
                                <Form.Check
                                  inline
                                  type="checkbox"
                                  id="edit-pets-cats"
                                  label="Cat"
                                  style={{ color: "#6c7581", fontWeight: "500" }}
                                  checked={editHasCats}
                                  onChange={(e) => setEditHasCats(e.target.checked)}
                                />
                                <Form.Check
                                  inline
                                  type="checkbox"
                                  id="edit-pets-dogs"
                                  label="Dog"
                                  style={{ color: "#6c7581", fontWeight: "500" }}
                                  checked={editHasDogs}
                                  onChange={(e) => setEditHasDogs(e.target.checked)}
                                />
                              </div>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>Appointment Instructions:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                value={editClientNotes}
                                onChange={(e) => setEditClientNotes(e.target.value)}
                                placeholder="Instructions for parking, access details and notes for the technician"
                                className="booking-custom-input p-2"
                                style={{
                                  height: "150px",
                                  border: "1px solid #ccc",
                                }}
                              />
                            </Form.Group>
                          </div>
                        </div>}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose3}>
            Cancel
          </Button>
          <Button variant="primary" onClick={UpdateBookigData}>
            Update
          </Button>
          {editbooking.recurring_id &&
            editbooking.recurring_id != 0 &&
            editbooking.recurring_id !== null &&
            editbooking.recurring_id !== "" ? (
            <Button
              className="primary btn-big-width"
              onClick={updaterecurringbooking}
            >
              {apicall ? (
                <Spinner animation="border" />
              ) : (
                "Update all recurring"
              )}
            </Button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>

      {usercrmid != 0 ? (
        <ChildComponent
          id={usercrmid}
          onCloseidChange={(editid) => setUsercrmid(editid)}
        />
      ) : (
        <></>
      )}

      <style>
        {`

            .ct-cal-booking-details-item.gregr {
              position: relative;
              display: flex;
              align-items: center;
            }

            .edit-icon {
              opacity: 0;
              transition: opacity 0.3s ease;
              cursor: pointer;
            }

            .ct-cal-booking-details-item:hover .edit-icon {
              opacity: 1;
            }

            .technician-string {
              position: relative;
              display: inline-flex;
              align-items: center;
              gap: 5px;
              cursor: pointer;
            }

            .edit-icon {
              opacity: 0;
              transition: opacity 0.3s ease-in-out;
            }

            .technician-string:hover .edit-icon {
              opacity: 1;
            }

                      `}
      </style>

      <NotificationContainer />
      {/* </>
        )} */}
    </div>
  );
}

function convertToHHMM(value) {
  const start_time = value;
  const hours = Math.floor(start_time / 60);
  const minutes = start_time % 60;

  // Format hours and minutes as two-digit numbers
  const formattedHours = hours < 10 ? "0" + hours : hours.toString();
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

  // Combine hours and minutes in the "00:00" format
  const formattedTime = formattedHours + ":" + formattedMinutes;
  return formattedTime;
}

function getpriceperhours(amount, baseminutes) {
  if (amount != 0 && baseminutes != 0) {
    const hours = baseminutes / 60;

    const priceperhours = amount / hours.toFixed(2);
    return priceperhours.toFixed(2);
  } else {
    return "0.00";
  }
}

function getCalculateddiscount(booking_price, booking_discount) {
  if (booking_price != 0 && booking_discount != 0) {
    const discount = parseInt(booking_price) - parseInt(booking_discount);
    return discount;
  } else {
    return "0.00";
  }
}

const calculateTotal = (rows, discount) => {
  let total = rows.reduce((acc, row) => acc + row.total, 0);
  total -= parseFloat(discount) || 0;
  // setcalculateTotal(total);
  return total.toFixed(2);
};

const EDIT_BOOKING_TIME_SLOTS = [
  { value: "08:00", label: "8:00 AM" },
  { value: "09:00", label: "9:00 AM" },
  { value: "10:00", label: "10:00 AM" },
  { value: "11:00", label: "11:00 AM" },
  { value: "12:00", label: "12:00 PM" },
  { value: "13:00", label: "1:00 PM" },
  { value: "14:00", label: "2:00 PM" },
  { value: "15:00", label: "3:00 PM" },
  { value: "16:00", label: "4:00 PM" },
  { value: "17:00", label: "5:00 PM" },
];

function normalizeRequestValue(request) {
  if (request == null || request === "null" || request === "undefined") {
    return "";
  }
  return String(request).trim();
}

function isEffectivelyEmptyRequest(request) {
  const normalized = normalizeRequestValue(request);
  if (!normalized) return true;

  const parsed = parseSpecialClientRequests(
    removeRequestedTechnicianFromRequest(normalized)
  );
  const requestedTechnician = getRequestedTechnician(normalized);

  return (
    !parsed.bookingTime &&
    !parsed.instructions &&
    !parsed.hasCats &&
    !parsed.hasDogs &&
    !requestedTechnician
  );
}

function buildEditSpecialClientRequest(
  bookingTime,
  clientNotes,
  hasCats,
  hasDogs,
  requestedTechnician
) {
  const hasContent =
    Boolean(bookingTime?.trim()) ||
    Boolean(clientNotes?.trim()) ||
    hasCats ||
    hasDogs ||
    Boolean(requestedTechnician?.trim());

  if (!hasContent) {
    return null;
  }

  let combined = `Instructions : ${clientNotes || ""}`;

  if (hasCats && hasDogs) {
    combined = `${combined}\nPets at Home: Dog and Cat`;
  } else if (hasCats) {
    combined = `${combined}\nPets at Home: Cat`;
  } else if (hasDogs) {
    combined = `${combined}\nPets at Home: Dog`;
  }

  if (requestedTechnician?.trim()) {
    combined += `\nRequested Technician : ${requestedTechnician.trim()}`;
  }

  return combined;
}

function getRequestedTechnician(request) {
  if (!request) return null;

  const requestedTechMatch = request.match(/Requested Technician\s*:\s*(.+?)(?:\r\n|\n|$)/i);

  if (requestedTechMatch && requestedTechMatch[1]) {
    return requestedTechMatch[1].trim();
  }

  return null;
}

function removeRequestedTechnicianFromRequest(request) {
  if (!request) return "";

  return request.replace(/Requested Technician\s*:\s*.+?(?:\r\n|\n|$)/gi, "").trim();
}

function parseSpecialClientRequests(request) {
  if (!request) return { bookingTime: "", instructions: "", hasCats: false, hasDogs: false };

  const bookingTimeMatch = request.match(/Booking Time\s*:\s*(.+?)(?:\r\n|\n|$)/i);
  const bookingTime = bookingTimeMatch && bookingTimeMatch[1] ? bookingTimeMatch[1].trim() : "";

  const instructionsMatch = request.match(/Instructions\s*:\s*([\s\S]*?)(?:\r\n|\n|(?:Pets at Home|Requested Technician)|$)/i);
  const instructions = instructionsMatch && instructionsMatch[1] ? instructionsMatch[1].trim() : "";

  const petsMatch = request.match(/Pets at Home\s*:\s*(.+?)(?:\r\n|\n|$)/i);
  let hasCats = false;
  let hasDogs = false;

  if (petsMatch && petsMatch[1]) {
    const petsValue = petsMatch[1].trim().toLowerCase();
    if (petsValue.includes("dog and cat") || petsValue.includes("cat and dog")) {
      hasCats = true;
      hasDogs = true;
    } else if (petsValue.includes("cat")) {
      hasCats = true;
    } else if (petsValue.includes("dog")) {
      hasDogs = true;
    }
  }

  return { bookingTime, instructions, hasCats, hasDogs };
}

export default Appointment;
